import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { DownloadOutlined } from "@ant-design/icons";
import { withAppContext } from "../../store/contextStore";
import NumberFormat from "react-number-format";
import uuid from "uuid";
import uniqBy from "lodash/uniqBy";
import _ from "lodash";
import {
  Row,
  Col,
  Button,
  Card,
  Typography,
  Table,
  Modal,
  Menu,
  Divider,
  Tag,
  Form,
  Input,
  Icon,
  Dropdown,
  message,
  Tabs,
  notification,
  Select,
  Switch,
  Popconfirm,
  Upload,
} from "antd";
import {
  ArrowLeftOutlined,
  StopOutlined,
  CheckOutlined,
  UserOutlined,
  CloseOutlined,
  EditOutlined,
  SyncOutlined,
  DownOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Docsample from "../../Images/pdf.jpg";
import AppConfigs from "../../Config/AppConfig";
import { API, Auth, Storage } from "aws-amplify";
import { getDetails, update, updateLocation, list } from "../../api/Apis";
import { listProducts } from "../../api/AllApis";
import priceFormate, { formatPhoneNumber } from "../commonFunctions";
import {
  updateCustomerOrCarrierDetails,
  getCustomerOrCarrierDetails,
} from "../../api/OraganizationApis";
import jsPDF from "jspdf";
import LocationAutocomplete from "../../Components/Autocomplete";
import { showTotal } from "../commonFunctions";
import RichText from "../../Components/Common/RichText";
import Uploaded from "../../Images/uploaded.png";
import Trash from "../../Images/trash.png";
import DeFeoImage from "../../Images/pdf_logo.png";
import moment from "moment";
import FormItem from "antd/lib/form/FormItem";
import ErrorPage from "../ErrorPage";
import { noWhitespaceRule, notValidPhoneNumberRule } from "../../utils/Utils";
import AppConfig from "../../Config/AppConfig";
const { Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;
class CustomerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loginModal: false,
      recordId: "",
      priceData: [],
      productsData: [],
      customerInfo: {},
      loginDetails: {},
      loading: false,
      locationLoading: false,
      productName: "",
      dataLoadingStatus: false,
      locationsVisible: false,
      edit: false,
      editdata: [],
      locations: [],
      locationModalTitle: "",
      latLangs: {},
      profileVisible: false,
      avtivationLoading: false,
      selectedAddress: "",
      selectedCustomerAddress: "",
      editMode: false,
      approveLoading: false,
      declineLoading: false,
      freezeAccountLoading: false,
      customerApproval: false,
      loadsList: [],
      creditAmtUpdate: false,
      deliveryEdit: false,
      showSaveIcon: false,
      defeoCompanyLogo: "",
      price: "",
      pallet: "",
      noteVisible: false,
      richtTextBiofield: "",
      bulkData: [],
      message: "",
      palletData: [],
      selectLocation: "",
      increaseVal: "",
      isCheckingPrices: false,
      backUp_bulkData: {},
      deliveryFee: 0,
      customerAuditDetails: [],
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      title: "",
      documentVisible: false,
      documentTitle: "",
      uploading: false,
      fileList: [],
      uploadName: "",
      documents: {},
      id: "",
      buttonText: "",
      subUserList: [],
      allUserList: [],
      subUserEdit: false,
      // editSubUserData: [],
      subuserId: "",
      formSubmitStatus: false,
      awsUsername: "",
      pricesheetModal: false,
      sendMailloading: false,
    };
  }

  async componentDidMount() {
    await this.getCustomerDetails("");
    await this.getDeliveryFee();
    await this.getAuditTrailsDetails();
  }

  getAuditTrailsDetails = () => {
    list("auditTrail", {
      typeofPage: "customerDetails",
      recordId: this.props.match.params.id,
    })
      .then((details) => {
        if (details.success) {
          let totalAudit = details.data.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : -1
          );
          // totalAudit = details.data.filter(eachAudit=>eachAudit.auditTrailDetails.filter(o=>o.changedFieldName !== "recordId"))
          this.setState({
            customerAuditDetails: totalAudit,
          });
        }
      })
      .catch((err) => console.log(err, "errrrr"));
  };

  locationHandleDelete = (keyToDelete) => {
    const { locations } = this.state;

    // Filter out the location to delete
    const updatedLocations = locations.filter(
      (location) => location.key !== keyToDelete
    );

    // Update the state with the new locations data
    this.setState(
      {
        locations: updatedLocations,
        locationsVisible: false,
        selectedAddress: "",
        editdata: [],
        edit: false,
      },
      () => console.log(this.state)
    );
  };

  getCustomerDetails = (locationSelect) => {
    this.setState({
      dataLoadingStatus: true,
    });
    getDetails(
      AppConfigs["getRegisterDetails"],
      this.props.match.params.id
    ).then(async (result) => {
      if (result.success) {
        let selectLocation = this.state.selectLocation;
        let customerDetails = result.data;
        let customerInfo = customerDetails["registerDetails"];
        let loginDetails = customerDetails["loginDetails"];
        let productsData = customerDetails["products"];
        let loadList = customerDetails["leads"];
        let subUserList = [];
        let allUserList = [];
        let locations = [];
        if (locationSelect === "") {
          selectLocation =
            customerInfo["customerLocations"] &&
            customerInfo["customerLocations"][0] &&
            customerInfo["customerLocations"][0]["location"];
          customerInfo["customerLocations"] &&
            this.setState({
              selectLocation,
            });
        }
        customerInfo["customerLocations"] &&
          customerInfo["customerLocations"].map((location, index) => {
            return locations.push({
              key: index,
              location: location["location"],
              address: location["address"],
              city: location["city"],
              state: location["state"],
              pincode: location["pincode"] ? location["pincode"] : "",
              latLng: location["latLng"] ? location["latLng"] : "",
              isActive: location["isActive"] && location["isActive"],
            });
          });
        if (productsData["Bulk Gravel"]) {
          productsData["Bulk Gravel"] = uniqBy(
            productsData["Bulk Gravel"],
            (obj) => obj.id
          );
        }
        productsData["Bulk Gravel"] &&
          productsData["Bulk Gravel"].map(async (product) => {
            product["image"] = await Storage.get(
              // product["sizes"][0] && product["sizes"][0]["sizeUploadImg"]
              product["images"]?.[0]
            );
            let orignalProductSize = JSON.parse(
              JSON.stringify(product["sizes"])
            );
            let modifyProductSize = product["sizes"];
            const object1 = product.sizes.map((item) => item.location);
            const object2 = locations.map((item) => item.location);
            const isEqual = _.isEqual(object1, object2);
            if (!isEqual) {
              const locationArray = [];
              Object.values(object2).map((item) => locationArray.push(item));
              product.sizes.map((item) => {
                if (locationArray.includes(item.location)) {
                  const index = locationArray.indexOf(item.location);
                  locationArray.splice(index, 1);
                }
              });
              if (product.isActive) {
                // eslint-disable-next-line array-callback-return
                modifyProductSize.map((item) => {
                  // eslint-disable-next-line array-callback-return
                  locationArray.map((location) => {
                    item.location = location;
                  });
                });
                if (locationArray.length > 0) {
                  modifyProductSize = [
                    ...modifyProductSize,
                    ...orignalProductSize,
                  ];
                }
              }
            }
            product["sizes"] = modifyProductSize;
            product["totalSizes"] = modifyProductSize;
            //FOR GETTING SINGLE LOCATION SIZE AND PRICES
            let sizes =
              product["sizes"] &&
              product["sizes"].filter(
                (singleLocatin) => singleLocatin.location === selectLocation
              );

            // if (sizes.length === 0) {
            //   sizes = product.sizes.map(
            //     (item) => (item = { ...item, price: "0.0" })
            //   );
            // }

            product["sizes"] =
              sizes.length === 0 ? product["totalSizes"] : sizes;
            // sizes.length === 0 ? product["totalSizes"] : sizes;

            this.setState({
              bulkData: productsData["Bulk Gravel"].sort(function (x, y) {
                return x.isActive === y.isActive ? 0 : x.isActive ? -1 : 1;
              }),
            });
          });
        productsData["Palletized Stone"] &&
          productsData["Palletized Stone"].map(async (product) => {
            product["image"] = await Storage.get(
              product["sizes"][0]["sizeUploadImg"]
            );
            //FOR GETTING SINGLE LOCATION SIZE AND PRICES
            let newSize = product["sizes"].filter(
              (elementSize, index, arr) =>
                arr.indexOf(elementSize.location) !== index
            );
            product["sizes"] = [newSize[0], newSize[1]];
            product["totalSizes"] = newSize;
            this.setState({
              palletData: productsData["Palletized Stone"],
            });
          });
        productsData["SuperSack"] &&
          productsData["SuperSack"].map(async (product) => {
            product["image"] = await Storage.get(
              product["sizes"]?.[0]?.["sizeUploadImg"]
            );
            //FOR GETTING SINGLE LOCATION SIZE AND PRICES
            let newSize = product["sizes"]?.filter(
              (elementSize, index, arr) =>
                arr.indexOf(elementSize.location) !== index
            );
            product["sizes"] = [newSize[0], newSize[1]];
            product["totalSizes"] = newSize;
            // console.log("++", [
            //   ...productsData["Palletized Stone"],
            //   ...productsData["SuperSack"],
            // ]);
            this.setState({
              palletData: [
                ...productsData["Palletized Stone"],
                ...productsData["SuperSack"],
              ],
            });
          });
        let customerAdmin = {
          id: uuid.v1(),
          email: customerDetails["registerDetails"]?.email,
        };
        allUserList.push(customerAdmin);
        subUserList =
          customerDetails["users"] &&
          customerDetails["users"].filter(
            (item) => item.email !== customerInfo.email
          );
        allUserList = [customerAdmin, ...subUserList];
        this.setState({
          customerInfo: customerInfo,
          locations: locations,
          loginDetails: loginDetails,
          productsData: productsData,
          loadsList: loadList,
          dataLoadingStatus: false,
          subUserList,
          allUserList,
        });
      } else {
        console.log(result.errors);
      }
    });
  };

  creditAppDownload = async (fileName) => {
    this.setState({
      pageLoading: true,
    });
    Storage.get(fileName, { download: true }).then((res) =>
      this.downloadBlob(res.Body, fileName)
    );
  };

  downloadPriceSheet = async () => {
    const { selectLocation } = this.state;
    console.log("selectLocation", selectLocation);

    const bulkData = this.state.bulkData;
    console.log("bulkData", bulkData);

    if (!bulkData || !selectLocation) {
      return;
    }
    const pdf = new jsPDF();

    pdf.addImage(DeFeoImage, "PNG", 15, 25, 50, 30);

    const customerInfo = this.state.customerInfo;
    const infoX = 15;
    const infoY = 65;
    const lineHeight = 5;

    pdf.setFontSize(12);

    pdf.text("DeFeo Materials, LLC.", 70, 30);
    pdf.text("Website: https://www.discountriverrock.com/", 70, 35);
    pdf.text("Phone: 888-884-6459", 70, 40);
    pdf.text("Address: 100 Bank Street, suite 205, Seymour, ct 06483", 70, 45);

    pdf.text(`Company: ${customerInfo.companyName}`, infoX, infoY);
    pdf.text(`Address: ${customerInfo.address}`, infoX, infoY + lineHeight);
    pdf.text(`Phone: ${customerInfo.phone}`, infoX, infoY + 2 * lineHeight);
    pdf.text(`Email: ${customerInfo.email}`, infoX, infoY + 3 * lineHeight);
    pdf.text(
      "Pricesheet generated on " + moment().format("MM/DD/YYYY"),
      15,
      20
    );

    pdf.setFontSize(10);

    const tableHeaders = [
      "Product Code",
      "Product Name",
      "Location",
      "Size",
      "Price",
    ];

    const filteredBulkData = bulkData.filter((data) => {
      // Filter out products that do not have the selected location
      const sizesForLocation = data.sizes.filter(
        (sizeData) => sizeData.location === selectLocation
      );
      return sizesForLocation.length > 0;
    });

    const tableRows = [];

    filteredBulkData.forEach((data) => {
      if (!data.isActive) {
        return;
      }
      data.sizes.forEach((sizeData) => {
        if (sizeData.location === selectLocation) {
          tableRows.push([
            data.productCode,
            data.productName,
            sizeData.location,
            sizeData.size,
            "$" + sizeData.price,
          ]);
        }
      });
    });

    const startY = 80 + 5 * lineHeight;
    const colWidths = [40, 40, 40, 30, 30]; // Adjust column widths as needed

    const pageWidth = pdf.internal.pageSize.width;
    const maxTableWidth = pageWidth - 20; // Leave some margin

    let totalColWidths = colWidths.reduce((sum, width) => sum + width, 0);
    if (totalColWidths > maxTableWidth) {
      const scaleFactor = maxTableWidth / totalColWidths;
      colWidths.forEach((width, index) => {
        colWidths[index] = width * scaleFactor;
      });
    }

    pdf.autoTable({
      head: [tableHeaders],
      body: tableRows,
      headStyles: {
        fillColor: "rgb(14, 77, 144)",
        textColor: "#fff",
        fontWeight: "bold",
      },

      startY,
      theme: "grid",
      columnStyles: {
        0: { cellWidth: colWidths[0] },
        1: { cellWidth: colWidths[1] },
        2: { cellWidth: colWidths[2] },
        3: { cellWidth: colWidths[3] },
        4: { cellWidth: colWidths[4] },
      },
    });

    pdf.save(`PriceSheet_${selectLocation}.pdf`);
    // console.log(this.state.customerInfo);
    // console.log("Downloaded price sheet");
  };

  handleUpload = async () => {
    let docKeys = this.state.documents ? this.state.documents : {},
      fileName;
    if (this.state.fileList.length === 0) {
      alert("Please upload at least one new document for update!");
      return;
    }
    this.setState({
      uploading: true,
    });
    await this.state.fileList.map(async (file, index) => {
      if (file["fileBelongsTo"]) {
        fileName = this.state.id + "_" + file["name"];
        await Storage.put(fileName, file, {
          contentType: file.type,
        })
          .then((result) => {
            docKeys[file["fileBelongsTo"]] = [];
            docKeys[file["fileBelongsTo"]].push(result.key);
            if (this.state.fileList.length === index + 1) {
              let data = {
                entityData: {
                  customerDocuments: docKeys,
                },
              };
              updateCustomerOrCarrierDetails(this.state.id, data).then(
                (result) => {
                  if (result.success) {
                    this.setState({
                      documentsUploaded: true,
                    });
                    getCustomerOrCarrierDetails(this.state.id).then(
                      (result) => {
                        if (result.success) {
                          this.setState({
                            documentVisible: false,
                            documentTitle: "",
                            customerInfo: result?.data,
                            uploading: false,
                            fileList: [],
                          });
                        }
                      }
                    );
                  } else {
                    console.log(result.errors);
                    this.setState({
                      documentVisible: false,
                      documentTitle: "",
                      uploading: false,
                      fileList: [],
                    });
                  }
                }
              );
            }
          })
          .catch((err) => console.log(err));
      }
    });
  };

  selectPriceByLocation = (selectLocation) => {
    const { bulkData } = this.state;

    let changePriceList = bulkData;
    changePriceList &&
      changePriceList.map(async (product) => {
        let sizes = product["totalSizes"].filter(
          (singleLocatin) => singleLocatin.location === selectLocation
        );
        if (sizes.length === 0) {
          sizes = product.sizes.map(
            (item) => (item = { ...item, price: "0.0" })
          );
        }
        product["sizes"] = sizes;
        this.setState({
          bulkData: changePriceList,
        });
      });
  };
  changeCustomerStatus = async (
    approvalStatus,
    isActive,
    lodingId,
    creditAmount = ""
  ) => {
    this.setState({
      [lodingId]: true,
    });
    let data = {};
    let creditAmountBalance =
      parseInt(creditAmount) -
      parseInt(this.state.customerInfo["creditAmount"]);

    if (this.state.creditAmtUpdate) {
      data["entityData"] = {
        creditAmount: parseInt(creditAmount),
        presentCreditAmount:
          parseInt(this.state.customerInfo["presentCreditAmount"]) +
          parseInt(creditAmountBalance),
      };
    } else {
      data["entityData"] = {
        approvalStatus: approvalStatus,
        isActive: isActive,
      };
      if (creditAmount !== "") {
        data["entityData"]["creditAmount"] = creditAmount;
        data["entityData"]["presentCreditAmount"] = this.state.customerInfo[
          "presentCreditAmount"
        ]
          ? this.state.customerInfo["presentCreditAmount"]
          : creditAmount;
      }
    }

    if (approvalStatus === "F" && creditAmount !== "") {
      data["entityData"] = {
        approvalStatus: approvalStatus,
        isActive: isActive,
        creditAmount: parseFloat(
          this.state.customerInfo["creditAmount"]
        ).toFixed(2),
        presentCreditAmount: creditAmount,
      };
    }
    let api = AppConfigs["entityNames"]["registrations"];
    data["entityData"]["typeofPage"] = "customerDetails";
    data["entityData"]["recordId"] = this.props.match.params.id;

    update(api, this.props.match.params.id, data).then((result) => {
      if (result.success) {
        if (isActive && this.state.customerInfo["approvalStatus"] === "P") {
          message.success("Customer activated successfully");
        } else {
          message.success("Record updated successfully");
        }
        this.setState({
          [lodingId]: false,
          creditAmtUpdate: false,
          customerApproval: false,
        });
        // window.location.reload();
        this.getAuditTrailsDetails();
        this.getCustomerDetails();
      } else {
        console.log(result.errors);
      }
    });
  };

  approveCustomer = () => {
    this.props.form.validateFieldsAndScroll(["creditAmount"], (err, values) => {
      if (!err) {
        if (this.state.creditAmtUpdate) {
          this.changeCustomerStatus(
            null,
            false,
            "approveLoading",
            values["creditAmount"]
          );
        } else {
          this.changeCustomerStatus(
            "A",
            true,
            "approveLoading",
            values["creditAmount"]
          );
        }
      }
    });
    //
  };

  showModal = (data, row) => {
    let priceData = [];
    data.map((price) => {
      return priceData.push({
        key: price.size,
        size: price.size,
        ton: parseFloat(price.ton).toFixed(2),
        pallet: parseFloat(price.pallet).toFixed(2),
        yard: parseFloat(price.yard).toFixed(2),
        sizeUploadImg: price.sizeUploadImg,
      });
    });
    this.setState({
      visible: true,
      recordId: row["id"],
      priceData: priceData,
      productName: row["productName"],
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  showLoginModal = () => {
    this.setState({
      loginModal: true,
    });
  };

  handleLoginOk = (e) => {
    this.setState({
      loginModal: false,
    });
  };

  async resendConfirmationCode(username) {
    try {
      this.setState({ avtivationLoading: true });
      await Auth.resendSignUp(username);
      this.setState({ avtivationLoading: false, loginModal: false });
      message.success("code resent successfully");
    } catch (err) {
      this.setState({ avtivationLoading: false });
      message.error(err.message);
      console.log("error resending code: ", err);
    }
  }

  handleLoginCancel = (e) => {
    this.setState({
      loginModal: false,
    });
  };

  getAddress = (address, latLng, fieldId) => {
    this.props.form.setFieldsValue({
      [fieldId]: address,
    });
    let latLangs = this.state.latLangs;
    latLangs[fieldId] = latLng;
    this.setState({
      latLangs,
    });
  };

  showLocationModal = async (key) => {
    await this.setState({
      editdata: [],
      selectedAddress: "",
    });
    const dataSource = this.state.locations;
    const edit = dataSource.filter((item) => item.key === key);
    await this.setState({
      locationModalTitle: "Edit Location",
      edit: true,
      editdata: edit,
      selectedAddress: edit[0]["address"],
      editMode: true,
    });
    await this.props.form.setFieldsValue({
      LocationName1: edit[0]["location"],
      Address1: edit[0]["address"],
    });
    this.setState({
      locationsVisible: true,
    });
  };

  addlocation = () => {
    this.setState({
      locationsVisible: true,
      locationModalTitle: "Add New Location",
      selectedAddress: "",
      editMode: false,
      edit: false,
    });
    this.props.form.setFieldsValue({
      LocationName1: "",
      Address1: "",
    });
  };

  locationHandleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["LocationName1", "Address1"],
      (err, values) => {
        if (!err) {
          let location = values["LocationName1"];
          this.setState({
            locationLoading: true,
          });
          let locations = [];
          if (this.state.edit) {
            this.state.locations.forEach((locationItem) => {
              if (locationItem["key"] === this.state.editdata[0]["key"]) {
                locations.push({
                  location: values["LocationName1"],
                  address: values["Address1"],
                  city: null,
                  state: null,
                  pincode: null,
                  latLng: this.state.latLangs["Address1"],
                });
              } else {
                locations.push({
                  location: locationItem["location"],
                  address: locationItem["address"],
                  city: locationItem["city"],
                  state: locationItem["state"],
                  pincode: locationItem["pincode"],
                  latLng: locationItem["latLng"],
                });
              }
            });
          } else {
            locations = this.state.locations;
            locations.push({
              location: values["LocationName1"],
              address: values["Address1"],
              city: values["City1"],
              state: values["State1"],
              latLng: this.state.latLangs["Address1"],
            });
          }
          let data = {
            entityData: {
              customerLocations: locations,
            },
          };
          update(
            AppConfigs["entityNames"]["registrations"],
            this.props.match.params.id,
            data
          ).then((result) => {
            if (result.success) {
              let locations = [];
              result.data["data"]["customerLocations"].forEach(
                (location, index) => {
                  locations.push({
                    key: index,
                    location: location["location"],
                    address: location["address"],
                    city: location["city"],
                    state: location["state"],
                  });
                }
              );

              message.success("Location Update Successfully");

              if (!this.state.edit) {
                let data = {
                  entityData: {
                    latLng: this.state.latLangs["Address1"],
                  },
                };
                updateLocation(
                  `approveCustomerLocation`,
                  `${this.props.match.params.id}/${location}`,
                  data
                ).then((result) => {
                  if (result.success) {
                    this.setState({
                      locations: locations,
                      locationsVisible: false,
                      selectedAddress: "",
                      editdata: [],
                      edit: false,
                      locationLoading: false,
                    });
                  }
                });
              } else {
                this.setState({
                  locations: locations,
                  locationsVisible: false,
                  selectedAddress: "",
                  editdata: [],
                  edit: false,
                  locationLoading: false,
                });
              }
            } else {
              console.log(result.errors);
              this.setState({
                locationLoading: false,
              });
            }
          });
        }
      }
    );
  };

  locationHandleCancel = () => {
    this.setState({
      locationsVisible: false,
      edit: false,
      editdata: [],
      selectedAddress: "",
    });
  };

  fileDownload = async (fileName, downloadFileName, companyName) => {
    let savedFileName;
    if (companyName !== null) {
      savedFileName = downloadFileName + "_" + companyName?.replace(/ /g, "");
    } else {
      savedFileName = downloadFileName;
    }
    this.setState({
      dataLoadingStatus: true,
    });
    Storage.get(fileName, { download: true }).then((res) =>
      this.downloadBlob(res.Body, savedFileName)
    );
  };

  downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    this.setState({
      dataLoadingStatus: false,
    });
    return a;
  }

  updateSizes = async (e) => {
    e.preventDefault();
    let fieldsNames = [];
    this.state.priceData.map((size) => {
      fieldsNames.push("ton" + size.size);
      fieldsNames.push("yard" + size.size);
      fieldsNames.push("pallet" + size.size);
      return size;
    });
    this.props.form.validateFieldsAndScroll(fieldsNames, (err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        let newPriceList = [];
        this.state.priceData.map((size) => {
          return newPriceList.push({
            size: size.size,
            ton: values["ton" + size.size],
            yard: values["yard" + size.size],
            pallet: values["pallet" + size.size],
            truckload: (values["ton" + size.size] * 24).toString(),
            sizeUploadImg: size.sizeUploadImg,
          });
        });
        let data = {
          entityData: {
            sizes: newPriceList,
          },
        };
        data["entityData"]["typeofPage"] = "customerDetails";
        data["entityData"]["recordId"] = this.props.match.params.id;
        update(
          AppConfigs["entityNames"]["products"],
          this.state.recordId,
          data
        ).then(async (result) => {
          if (result.success) {
            this.setState({
              priceData: [],
              recordId: "",
              loading: false,
              visible: false,
            });
            message.success("Updated successfully!");
            this.getAuditTrailsDetails();

            let query = {
              customerId: this.props.match.params.id,
              isActive: true,
            };
            this.setState({
              productsData: [],
            });
            let productsData = await listProducts(query);
            let productLen = 0;
            productsData.map(async (product, index) => {
              productLen += 1;
              product["image"] = await Storage.get(product["images"][0]);
              if (productsData.length === productLen) {
                this.setState({
                  productsData: productsData,
                });
              }
            });
            this.setState({
              loading: false,
              productsData: productsData,
            });
          } else {
            this.setState({
              loading: false,
            });
            console.log(result.errors);
          }
        });
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    let productsData = [];
    if (sorter["order"] === "descend") {
      if (sorter["columnKey"] === "productCode") {
        productsData = this.state.productsData.sort((a, b) =>
          a["productCode"].toLowerCase() < b["productCode"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "productName") {
        productsData = this.state.productsData.sort((a, b) =>
          a["productName"].toLowerCase() < b["productName"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "description") {
        productsData = this.state.productsData.sort((a, b) =>
          a["description"].toLowerCase() < b["description"].toLowerCase()
            ? 1
            : -1
        );
      }
    } else if (sorter["order"] === "ascend") {
      if (sorter["columnKey"] === "productCode") {
        productsData = this.state.productsData.sort((a, b) =>
          a["productCode"].toLowerCase() > b["productCode"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "productName") {
        productsData = this.state.productsData.sort((a, b) =>
          a["productName"].toLowerCase() > b["productName"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "description") {
        productsData = this.state.productsData.sort((a, b) =>
          a["description"].toLowerCase() > b["description"].toLowerCase()
            ? 1
            : -1
        );
      }
    } else {
      productsData = this.state.productsData;
    }
    this.setState({
      productsData: productsData,
    });
  };

  showProfileModal = () => {
    const userData = this.state.customerInfo;
    const customerName = this.state.loginDetails;
    this.setState({
      profileVisible: true,
      selectedCustomerAddress: userData.address,
    });
    this.props.form.setFieldsValue({
      firstName: customerName.firstName,
      lastName: customerName.lastName,
      phone: userData.phone,
      companyName: userData.companyName,
      address: userData.address,
      email: userData.email,
    });
  };

  profileHandleCancel = (e) => {
    this.setState({
      profileVisible: false,
    });
  };

  logoutuser = async () => {
    const AWS = require("aws-sdk");

    AWS.config.update({
      accessKeyId: `${AppConfig.APP_ACCESS_KEY_ID}`,
      secretAccessKey: `${AppConfig.SECRET_ACCESS_KEY_ID}`,
      region: `${AppConfig.APP_COGNITO_REGION}`, // e.g., 'us-east-1'
    });

    const cognitoIdentityServiceProvider =
      new AWS.CognitoIdentityServiceProvider();

    const userPoolId = `${AppConfig.APP_COGNITO_USER_POOL_ID}`;
    const username = this.state.awsUsername;

    const params = {
      UserPoolId: userPoolId,
      Username: username,
    };

    cognitoIdentityServiceProvider.adminUserGlobalSignOut(
      params,
      (err, data) => {
        if (err) {
          console.error("Error logging out the user:", err);
        } else {
          console.log("Customer logged out successfully:", data);
        }
      }
    );
  };

  //  updateUser=async (username, attributeValue) =>{
  //     try {
  //       const response = await API.post('cognito-idp', '/adminUpdateUserAttributes', {
  //         body: {
  //           UserPoolId: AppConfig.APP_COGNITO_USER_POOL_ID,
  //           Username: username,
  //           UserAttributes: [
  //             {
  //               Name: 'email',
  //               Value: attributeValue
  //             }
  //           ]
  //         }
  //       });
  //       console.log('User attribute updated:', response);
  //     } catch (error) {
  //       console.error('Error updating user attribute:', error);
  //     }
  //   }

  // updateUser = async (username, attributes) => {

  //   const userPoolId=AppConfig.APP_COGNITO_USER_POOL_ID
  //   debugger
  //   Auth.adminUpdateUserAttributes(userPoolId, username, attributes)
  //   .then(result => {
  //     console.log('User attributes updated successfully:', result);
  //   })
  //   .catch(error => {
  //     console.log('Error updating user attributes:', error);
  //   });

  //   // var createPromise = Auth.CognitoIdentityServiceProvider().adminUpdateUserAttributes(params).promise();
  //   // await createPromise;
  //   // await cognitoidentityserviceprovider
  //   //   .adminUpdateUserAttributes(params)
  //   //   .then((data) => {
  //   //     console.log(data);
  //   //     this.setState({ loading: false });
  //   //   })
  //   //   .catch((err) => {
  //   //     if (err.code === "InvalidPasswordException") {
  //   //       message.error(
  //   //         "Invalid Password: \n- Minimum password length:6\n- Require at least one uppercase letter\n- Require at least one lowercase letter\n- Require at least one number\n- Require at least one nonalphanumeric character"
  //   //       );
  //   //       this.setState({ loading: false });
  //   //     } else {
  //   //       message.error(err.message);
  //   //       this.setState({ loading: false });
  //   //     }
  //   //   });
  //   // const user = await Auth.currentUserPoolUser();
  //   // console.log(user)
  //   // await Auth.updateUserAttributes(user, {
  //   //   'email': email
  //   // },{
  //   //   Name: "email_verified",
  //   //   Value: "false"
  //   // }).
  //   // await Auth.currentUserPoolUser().then((data) => {
  //   // console.log(data)
  //   // this.setState({loading: false });
  //   // })
  //   // .catch((err) => {
  //   //   if (err.code === "InvalidPasswordException") {
  //   //     message.error(
  //   //       "Invalid Password: \n- Minimum password length:6\n- Require at least one uppercase letter\n- Require at least one lowercase letter\n- Require at least one number\n- Require at least one nonalphanumeric character"
  //   //     );
  //   //     this.setState({loading: false });
  //   //   } else {
  //   //     message.error(err.message);
  //   //     this.setState({loading: false });
  //   //   }
  //   // });
  // };
  updateUserDetails = async (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["firstName", "lastName", "companyName", "address", "email"],
      async (err, values) => {
        if (!err) {
          this.setState({
            loading: true,
          });
          let data = {};
          data["entityData"] = {};
          data["entityData"]["firstName"] = values["firstName"];
          data["entityData"]["lastName"] = values["lastName"];
          data["entityData"]["email"] = values["email"];
          data["entityData"]["typeofPage"] = "customerDetails";
          data["entityData"]["recordId"] = this.props.match.params.id;
          let orgDetails = this.state.customerInfo;
          update(
            AppConfigs["entityNames"]["users"],
            this.state?.loginDetails?.["id"],
            data
          ).then(async (result) => {
            if (result.success) {
              data = {};
              data["entityData"] = {};
              // data["entityData"]["phone"] = values["phone"];
              data["entityData"]["companyName"] = values["companyName"];
              data["entityData"]["address"] = values["address"];
              data["entityData"]["email"] = values["email"];
              data["entityData"]["typeofPage"] = "customerDetails";
              data["entityData"]["recordId"] = this.props.match.params.id;
              update(
                AppConfigs["entityNames"]["registrations"],
                orgDetails["id"],
                data
              ).then(async (result) => {
                if (result.success) {
                  message.success("Profile updated successfully.");
                  this.setState({
                    loading: false,
                    profileVisible: false,
                  });
                  this.getCustomerDetails();
                  this.getAuditTrailsDetails();
                  // this.logoutuser();
                } else {
                  message.error("Profile updation failed.");
                  this.setState({
                    loading: false,
                  });
                  console.log(result.errors);
                }
              });
            } else {
              this.setState({
                loading: false,
              });
              console.log(result.errors);
            }
          });

          // For update Cognito user email
          // let username, params;
          // const AWS = require("aws-sdk");
          // AWS.config.update({
          //   accessKeyId: `${AppConfig.APP_ACCESS_KEY_ID}`,
          //   secretAccessKey: `${AppConfig.SECRET_ACCESS_KEY_ID}`,
          //   region: `${AppConfig.APP_COGNITO_REGION}`, // e.g., 'us-east-1'
          // });
          // const cognitoIdentityServiceProvider =
          //   new AWS.CognitoIdentityServiceProvider();
          // const userPoolId = `${AppConfig.APP_COGNITO_USER_POOL_ID}`;
          // const emailToSearch = this.state.customerInfo.email; // The email address you want to search for
          // params = {
          //   UserPoolId: userPoolId,
          //   Filter: `email = "${emailToSearch}"`,
          //   Limit: 1, // Set the limit to 1 to get only one matching user (assuming the email is unique)
          // };
          // cognitoIdentityServiceProvider.listUsers(params, (err, response) => {
          //   if (err) {
          //     console.error("Error searching for the user:", err);
          //     message.error("Error searching for the user:", err.message);
          //     this.setState({
          //       loading: false,
          //     });
          //   } else {
          //     if (response.Users.length > 0) {
          //       const user = response.Users[0];
          //       username = user.Username;
          //       this.setState({
          //         awsUsername: user.Username,
          //       });
          //       const newEmail = values["email"];
          //       params = {
          //         UserPoolId: userPoolId,
          //         Username: username,
          //         UserAttributes: [
          //           {
          //             Name: "email",
          //             Value: newEmail,
          //           },
          //         ],
          //       };
          //       cognitoIdentityServiceProvider.adminUpdateUserAttributes(
          //         params,
          //         (err, res) => {
          //           if (err) {
          //             message.error(err.message);
          //             this.setState({
          //               loading: false,
          //             });
          //           } else {
          //             message.success("User email updated successfully:", res);
          //             update(
          //               AppConfigs["entityNames"]["users"],
          //               this.state?.loginDetails?.["id"],
          //               data
          //             ).then(async (result) => {
          //               if (result.success) {
          //                 data = {};
          //                 data["entityData"] = {};
          //                 data["entityData"]["phone"] = values["phone"];
          //                 data["entityData"]["companyName"] =
          //                   values["companyName"];
          //                 data["entityData"]["address"] = values["address"];
          //                 data["entityData"]["email"] = values["email"];
          //                 data["entityData"]["typeofPage"] = "customerDetails";
          //                 data["entityData"]["recordId"] =
          //                   this.props.match.params.id;
          //                 update(
          //                   AppConfigs["entityNames"]["registrations"],
          //                   orgDetails["id"],
          //                   data
          //                 ).then(async (result) => {
          //                   if (result.success) {
          //                     message.success("Profile updated successfully.");
          //                     this.setState({
          //                       loading: false,
          //                       profileVisible: false,
          //                     });
          //                     this.getCustomerDetails();
          //                     this.getAuditTrailsDetails();
          //                     // this.logoutuser();
          //                   } else {
          //                     message.error("Profile updation failed.");
          //                     this.setState({
          //                       loading: false,
          //                     });
          //                     console.log(result.errors);
          //                   }
          //                 });
          //               } else {
          //                 this.setState({
          //                   loading: false,
          //                 });
          //                 console.log(result.errors);
          //               }
          //             });
          //           }
          //         }
          //       );
          //     } else {
          //       console.log("User with email not found:", emailToSearch);
          //     }
          //     this.setState({
          //       loading: false,
          //     });
          //   }
          // });
        }
      }
    );
  };

  updateNoteDetails = (e) => {
    e.preventDefault();
    let data = {
      entityData: {
        richTextEditior: this.state.richtTextBiofield,
      },
    };
    data["entityData"]["typeofPage"] = "customerDetails";
    data["entityData"]["recordId"] = this.props.match.params.id;

    update(
      AppConfigs["entityNames"]["users"],
      this.state?.loginDetails?.["id"],
      data
    )
      .then(async (result) => {
        if (result.success) {
          this.getCustomerDetails();
          this.setState({
            noteVisible: false,
          });
          this.getAuditTrailsDetails();
        }
      })
      .catch((error) => {
        this.setState({
          noteVisible: false,
        });
        console.log(error);
        notification["error"](console.log(error));
      });
  };

  handleInputChange = (e, type, indexData, id, sizeData) => {
    const finalData =
      type === "price"
        ? this.state.productsData["Bulk Gravel"]
        : this.state.productsData["Palletized Stone"];
    finalData &&
      finalData.map((single, index) => {
        let record = single[type === "price" ? "sizes" : "totalSizes"];
        if (record.length > 0) {
          record.map((size, ind) => {
            if (single.id === id) {
              if (indexData === ind) {
                if (type === "price") {
                  size["price"] = e;
                  // size["location"] = this.state.selectLocation;
                  this.setState({
                    price: {
                      value: e,
                      key: ind,
                    },
                  });
                } else {
                  if (type === "weight") {
                    size["ton"] = e;
                    this.setState({
                      ton: {
                        value: e,
                        key: ind,
                      },
                    });
                  } else {
                    size["price"] = e;
                    this.setState({
                      price: {
                        value: e,
                        key: ind,
                      },
                    });
                  }
                }
              } else {
                if (
                  type === "weight" &&
                  sizeData.size === size["size"] &&
                  sizeData.location !== size["location"]
                ) {
                  size["ton"] = e;
                } else {
                  if (
                    type === "pallet" &&
                    sizeData.size === size["size"] &&
                    sizeData.location !== size["location"]
                  ) {
                    size["price"] = e;
                  }
                }
              }
            }
            return true;
          });
        }
      });
  };

  saveSizechanges = (id, type) => {
    this.setState({
      dataLoadingStatus: true,
    });
    let newPriceList = [];
    let productNameSize = "";
    const finalData =
      type === "price"
        ? this.state.productsData["Bulk Gravel"]
        : this.state.productsData["Palletized Stone"];
    finalData.map((single, index) => {
      if (single.id === id) {
        newPriceList = single.totalSizes;
        productNameSize = single.productName;
      }
      return true;
    });
    console.log("+++", this.state.locations);
    // if (!(newPriceList[0].location === this.state.selectLocation)) {
    //   newPriceList[0]["location"] = this.state.selectLocation;
    // }
    // const a = [
    //   {
    //     ton: 1.5,
    //     truckload: "36",
    //     location: "Test",
    //     size: '1"',
    //     sizeUploadImg: null,
    //     price: "70.0",
    //   },
    //   {
    //     ton: 1.5,
    //     truckload: "36",
    //     location: "Home",
    //     size: '1"',
    //     sizeUploadImg: null,
    //     price: "30.0",
    //   },
    // ];
    let data = {
      entityData: {
        sizes: newPriceList,
        isCustomized: true,
        productName: productNameSize,
      },
    };

    const check =
      newPriceList &&
      newPriceList.filter((item) => {
        if (item.ton === "" && item.pallet === "") {
          return false;
        } else if (item.ton !== "" && item.pallet !== "") {
          return true;
        }
        return false;
      });
    if (check.length === newPriceList.length) {
      this.setState({ showSaveIcon: false, deliveryEdit: false });
      this.updateApi(id, data, "price");
    } else {
      notification["error"]({
        message: "Please input your value",
      });
    }
  };

  deliveryEdit = (id) => {
    this.setState({
      deliveryEdit: id,
      showSaveIcon: true,
      ton: {
        value: "",
        key: "",
      },
      pallet: {
        value: "",
        key: "",
      },
      price: {
        value: "",
        key: "",
      },
    });
  };

  handleRichtextBio = (bio) => {
    this.setState({
      richtTextBiofield: bio,
    });
  };

  showTextModal = (value) => {
    const buttonTitle = value?.split(" ")[0] === "Edit" ? "Update" : "Add";
    this.setState({
      noteVisible: true,
      title: value,
      buttonText: buttonTitle,
    });
  };

  showDocumentModal = (value) => {
    this.setState({
      documentVisible: true,
      documentTitle: value,
    });
  };

  cancelPriceSheet = () => {
    this.getCustomerDetails();
    this.setState({
      showSaveIcon: false,
      deliveryEdit: false,
    });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.approveCustomer();
    }
  };

  handleLocations = (value) => {
    this.setState({
      dataLoadingStatus: true,
    });
    setTimeout(() => {
      this.setState({
        selectLocation: value,
        dataLoadingStatus: false,
      });
    }, 1000);

    this.selectPriceByLocation(value);
  };

  updateNumber = (e, type) => {
    const val = e.target.value;
    if (e.target.validity.valid) {
      if (type === "delivery") {
        this.setState({
          deliveryFee: e.target.value,
        });
      } else {
        this.setState({
          increaseVal: e.target.value,
        });
      }
    } else if (val === "" || val === "-") {
      this.setState({
        increaseVal: val,
      });
    }
  };

  calculateCustomerPrice = (id, type, location) => {
    if (this.state.increaseVal === "") {
      message.error("Please enter margin");
      return;
    }
    this.setState({
      isCheckingPrices: true,
      backUp_bulkData: JSON.stringify(this.state.bulkData),
    });
    let bulkData = this.state.bulkData;
    let index = 0;
    bulkData.map(async (product) => {
      product["sizes"].map((size) => {
        if (location === size["location"]) {
          let marginPrice =
            (parseInt(size.price) * parseInt(this.state.increaseVal)) / 100;
          size["price"] = size.price
            ? (parseInt(size.price) + marginPrice).toFixed(0)
            : 0;
          size["marginPrice"] = marginPrice.toFixed(0);
          size["truckload"] = parseInt(size["price"]) * 24;
        }
        return size;
      });
      index += 1;
      if (bulkData.length === index) {
        this.setState({
          bulkData,
        });
      }
    });
  };

  cancelPriceUpdate = async () => {
    await this.setState({
      bulkData: JSON.parse(this.state.backUp_bulkData),
      isCheckingPrices: false,
      increaseVal: "",
    });
  };

  updateCustomerPrice = (id, type, location) => {
    this.setState({
      loading: true,
    });
    let data = {
      entityData: {
        incrementVal: this.state.increaseVal,
        categoryId: id,
        location: location,
      },
    };
    data["entityData"]["typeofPage"] = "customerDetails";
    data["entityData"]["recordId"] = this.props.match.params.id;
    update(
      AppConfigs["updateCustomerProductPrices"],
      this.props.match.params.id,
      data
    )
      .then((result) => {
        if (result.success) {
          message.success("Price updated successfully!");
          this.setState({
            loading: false,
            isCheckingPrices: false,
            increaseVal: "",
          });
          this.getCustomerDetails();
          this.getAuditTrailsDetails();
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loading: false,
          isCheckingPrices: false,
          increaseVal: "",
        });
      });
  };

  updateDeliveryFee = () => {
    this.setState({
      loading: true,
    });
    if (this.state.deliveryFee === "") {
      message.error("Please enter delivery fee");
      this.setState({
        loading: false,
      });
      return;
    } else {
      let data = {
        entityData: {
          deliveryFee: this.state.deliveryFee,
        },
      };
      data["entityData"]["typeofPage"] = "customerDetails";
      data["entityData"]["recordId"] = this.props.match.params.id;
      update(
        "customerAndCarrierRegistrations",
        this.props.match.params.id,
        data
      )
        .then((result) => {
          if (result.success) {
            message.success("DeliveryFee updated successfully!");
            this.setState({
              loading: false,
            });
            this.getDeliveryFee();
            this.getAuditTrailsDetails();
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            loading: false,
          });
        });
    }
  };

  getDeliveryFee = () => {
    getDetails(
      "customerAndCarrierRegistrations",
      this.props.match.params.id
    ).then((result) => {
      if (result.success) {
        this.setState({
          deliveryFee: result.data?.deliveryFee,
          documents: result.data?.customerDocuments,
          id: result.data?.id,
        });
      }
    });
  };

  updateStatus = (id, check) => {
    this.setState({
      dataLoadingStatus: true,
    });
    let data = {
      entityData: {
        isActive: check,
        locations: this.state.locations,
      },
    };

    this.updateApi(id, data, "status");
  };

  updateApi = (id, data, type) => {
    data["entityData"]["typeofPage"] = "customerDetails";
    data["entityData"]["recordId"] = this.props.match.params.id;
    update(
      type === "status"
        ? AppConfigs["entityNames"]["newProductCalculation"]
        : AppConfigs["entityNames"]["customerProducts"],
      id,
      data
    )
      .then(async (result) => {
        if (result.success) {
          if (type === "price") {
            this.getCustomerDetails("locationSet");
            this.getAuditTrailsDetails();

            this.setState({
              pallet: "",
              price: "",
              ton: "",
            });
          } else {
            this.getCustomerDetails();
            this.getAuditTrailsDetails();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleTabChange = () => {
    this.setState({
      increaseVal: "",
    });
  };

  handleStatus = (id, check) => {
    this.updateStatus(id, check);
  };

  sendPricesheet = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["emails", "location"],
      async (err, values) => {
        let listOfEmails = values.emails.toString();
        if (!err) {
          this.setState({
            dataLoadingStatus: true,
            sendMailloading: true,
          });
          getDetails(
            AppConfigs["sendPriceQuote"],
            `${this.props.match.params.id}?userEmails=${encodeURIComponent(
              listOfEmails
            )}&selectLocation=${values["location"]}`
          ).then(async (result) => {
            if (result.success) {
              message.success("Email sent successfully!");
              this.props.form.resetFields();
              this.setState({
                dataLoadingStatus: false,
                pricesheetModal: false,
                sendMailloading: false,
              });
            } else {
              console.log(result.errors);
              this.setState({
                dataLoadingStatus: false,
                pricesheetModal: false,
                sendMailloading: false,
              });
            }
          });
        }
      }
    );
  };

  confirm = (e) => {
    this.sendPricesheet(e);
  };

  cancel = (e) => {
    console.log(e);
  };

  // locationActive = (record) => {
  //   console.log(record);
  //   let data = {
  //     entityData: {
  //       latLng: record.latLng,
  //     },
  //   };
  //   updateLocation(
  //     `approveCustomerLocation`,
  //     `${this.props.match.params.id}/${record.location}`,
  //     data
  //   ).then((result) => {
  //     if (result.success) {
  //       message.success("Location updated successfully!");
  //       // window.location.reload();
  //     }
  //   });
  // };

  handleEventRender = (event, record) => {
    return (
      <>
        {event.changedFieldName === "firstName" ? (
          <>
            <p style={{ color: "black", fontSize: "14px" }}>
              First Name Changed from <b>{event.oldFields}</b> to{" "}
              <b>{event.modifiedField}</b>
            </p>
          </>
        ) : event.changedFieldName === "lastName" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Last Name Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "richTextEditior" ? (
          <div style={{ display: "flex" }}>
            Notes Changed from &nbsp;{" "}
            <div
              dangerouslySetInnerHTML={{
                __html: `${event.oldFields ? event.oldFields : ""}`,
              }}
            />{" "}
            &nbsp; to &nbsp;{" "}
            <div
              dangerouslySetInnerHTML={{
                __html: `${event.modifiedField ? event.modifiedField : ""}`,
              }}
            />
          </div>
        ) : event.changedFieldName === "presentCreditAmount" &&
          "orderId" in record === true ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            {"orderId" in record === true &&
              record.orderId !== "" &&
              "orderData" in record === true &&
              (record.orderData?.orderStatus === "OP" ||
                record.orderData?.orderStatus === "N") &&
              "orderData" in record === true &&
              "priceUpdatedStatus" in record.orderData === false && (
                <>
                  New Order <b>#{record.orderId}</b> Placed,{" "}
                </>
              )}{" "}
            {"orderData" in record === true &&
              record.orderData?.markAsPaid &&
              !record.orderData?.markAsInvoiced && (
                <>
                  Order #{record.orderId} <b>Marked as Paid</b>,{" "}
                </>
              )}
            {"orderData" in record === true &&
              record.orderData?.priceUpdatedStatus && (
                <>
                  Order <b>#{record.orderId}</b> Price Updated,{" "}
                </>
              )}
            {"orderData" in record === true &&
              record.orderData?.orderStatus === "D" &&
              !record.orderData?.markAsPaid &&
              !record.orderData?.markAsInvoiced && (
                <>
                  Order <b>#{record.orderId}</b> Marked as Delivered,{" "}
                </>
              )}
            Credit Available changed from{" "}
            <b>{event.oldFields !== "" && priceFormate(event.oldFields)}</b>
            {" to "}
            <b>{priceFormate(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "creditAmount" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Credit Limit updated from{" "}
            <b>{event.oldFields !== "" && priceFormate(event.oldFields)}</b>
            {" to "}
            <b>{priceFormate(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "address" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Address Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "phone" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Phone Changed from <b> {formatPhoneNumber(event.oldFields)} </b> to{" "}
            <b>{formatPhoneNumber(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "companyName" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Company Name Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "location" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            New Location Added <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "approvalStatus" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            {event.modifiedField === "A" ? (
              <b>Account approved </b>
            ) : (
              event.modifiedField === "F" && <b>Account Frozen</b>
            )}
          </p>
        ) : event.changedFieldName === "price" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Product{" "}
            {"productName" in record === true && <b> {record.productName}</b>}{" "}
            Price Changes to <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : // : event.changedFieldName === "productCode" ? (
        //   <p style={{ color: "black", fontSize: "14px" }}>
        //     <i> {event.productCode}</i> Product Item
        //     {event.modifiedField  ? <b> Activated </b> : <b> Deactivated </b>}
        //   </p>
        // )
        event.changedFieldName === "isActive" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            <i> {event.productCode}</i> is
            {event.modifiedField ? <b> Activated </b> : <b> Deactivated </b>}
          </p>
        ) : (
          ""
        )}
      </>
    );
  };

  deleteDocument = async (item) => {
    this.setState({
      loading: true,
    });
    let updatedDocuments = { ...this.state.documents };
    updatedDocuments[item] = [];
    let data = {
      entityData: {
        customerDocuments: updatedDocuments,
      },
    };
    updateCustomerOrCarrierDetails(this.state.id, data).then(async (result) => {
      if (result.success) {
        message.success("Document deleted successfully");
        await getCustomerOrCarrierDetails(this.state.id).then((result) => {
          if (result.success) {
            this.setState({
              customerInfo: result.data,
              loading: false,
            });
          }
        });
      } else {
        console.log(result.errors);
      }
    });
    this.setState({
      loading: false,
    });
  };

  showSubUserEditModal = (id) => {
    const dataSource = this.state.subUserList;
    const subUserData = dataSource.filter((item) => item.id === id);
    this.props.form.setFieldsValue({
      subUserfirstName: subUserData[0]["firstName"],
      subUserlastName: subUserData[0]["lastName"],
      subUserphone: subUserData[0]["phone"],
      subUseremail: subUserData[0]["email"],
      subUseruserProfile: subUserData[0]["userProfile"],
    });
    this.setState({
      subUserEdit: true,
      subuserId: id,
    });
  };

  handleEditSubUserCancel = (e) => {
    e.preventDefault();
    this.setState({
      subUserEdit: false,
      // editSubUserData: [],
      subuserId: "",
    });
  };

  handleEditSubUser = (e) => {
    this.props.form.validateFieldsAndScroll(
      [
        "subUserfirstName",
        "subUserlastName",
        "subUserphone",
        "subUseremail",
        "subUseruserProfile",
      ],
      (err, values) => {
        if (!err) {
          this.setState({
            formSubmitStatus: true,
          });
          let data = {};
          let subUser = [];
          if (values.subUseruserProfile === "Customer Admin") {
            values.userProfile = "CU";
          } else if (values.subUseruserProfile === "Sub User") {
            values.userProfile = "SCU";
          }
          subUser.push({
            firstName: values["subUserfirstName"],
            lastName: values["subUserlastName"],
            phone: values["subUserphone"],
            email: values["subUseremail"],
            userProfile: values["subUseruserProfile"]
              ? values["subUseruserProfile"]
              : values["userProfile"],
          });
          data["entityData"] = subUser[0];
          update(
            AppConfigs["entityNames"]["users"],
            this.state.subuserId,
            data
          ).then((result) => {
            if (result.success) {
              message.success(`User details updated successfully.`);
              this.getCustomerDetails();
              this.props.form.resetFields();
              this.setState({
                formSubmitStatus: false,
                subUserEdit: false,
                subuserId: "",
              });
            } else {
              message.error(result.errors);
            }
          });
        }
      }
    );
  };

  changeSubCustomerStatus = async (isActive, id) => {
    this.setState({
      loading: true,
    });
    let data = {
      entityData: {
        isActive: isActive,
      },
    };
    update(AppConfigs["entityNames"]["users"], id, data).then((result) => {
      if (result.success) {
        message.success(`User details updated successfully.`);
        this.getCustomerDetails();
      } else {
        console.log(result.errors);
      }
    });
  };
  // handleDelete = (key) => {
  //   const dataSource = [...this.state.locations];
  //   this.setState({ locations: dataSource.filter((item) => item.key !== key) });
  // };

  handleDelete = (key) => {
    console.log("Before deletion:", this.state.locations);

    const dataSource = [...this.state.locations];
    this.setState(
      { locations: dataSource.filter((item) => item.key !== key) },
      () => {
        console.log("After deletion:", this.state.locations);
      }
    );
  };

  render() {
    const firstupload = {
      // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
      onChange({ file, fileList }) {
        if (file.status !== "uploading") {
        }
      },
      beforeUpload: (file) => {
        file["fileBelongsTo"] = "creditApp";
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
    };
    const secondupload = {
      // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
      onChange({ file, fileList }) {
        if (file.status !== "uploading") {
        }
      },
      beforeUpload: (file) => {
        file["fileBelongsTo"] = "rc";
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
    };
    const rolePermisions = this.props?.context?.state?.permissions;
    const menu = (
      <Menu>
        {this.state.customerInfo["approvalStatus"] !== "D" && (
          <Menu.Item key="1">
            <Popconfirm
              title="Do you want to email the price sheet to the customer?"
              onConfirm={() => {
                this.setState({ pricesheetModal: true });
              }}
              onCancel={this.cancel}
              okText="Yes"
              cancelText="No"
            >
              <h3 style={{ color: "#0e4d90" }}>SEND PRICE SHEET</h3>
            </Popconfirm>
          </Menu.Item>
        )}
        <Menu.Item key="2" onClick={this.showLoginModal}>
          <h3 style={{ color: "#0e4d90" }}>LOGIN DETAILS</h3>
        </Menu.Item>
      </Menu>
    );
    const { getFieldDecorator } = this.props.form;
    const { locations, selectLocation, customerAuditDetails } = this.state;

    const auditColumns = [
      {
        title: "DATE AND TIME",
        dataIndex: "createdAt",
        key: "createdAt",
        align: "left",
        width: "25%",
        render: (createdAt) => (
          <p style={{ color: "black", fontSize: "14px" }}>
            {moment(createdAt).format("MM/DD/YYYY hh:mm a")}
          </p>
        ),
      },
      {
        title: "ACTION DONE BY",
        dataIndex: "firstName",
        key: "createdAt",
        align: "left",
        width: "25%",
        render: (firstName, record) => (
          <p style={{ color: "black", fontSize: "14px" }}>
            {record.firstName + " " + record.lastName}
          </p>
        ),
      },
      {
        title: "EVENT",
        dataIndex: "auditTrailDetails",
        key: "auditTrailDetails",
        render: (auditTrailDetails, record) => (
          <>
            {record.auditTrailDetails.map((change) =>
              this.handleEventRender(change, record)
            )}
          </>
        ),
      },
    ];
    const priceColumns = [
      {
        title: "Size",
        dataIndex: "size",
        key: "size",
        width: "100px",
      },
      {
        title: "$/per ton",
        dataIndex: "ton",
        key: "ton",
        render: (data, record) => (
          <Form.Item className="Formitem">
            {getFieldDecorator("ton" + record.size, {
              rules: [{ required: true, message: "Please input ton value!" }],
              initialValue: data,
            })(<Input />)}
          </Form.Item>
        ),
      },
      {
        title: "$/per pallet",
        dataIndex: "pallet",
        key: "pallet",
        render: (data, record) => (
          <Form.Item className="Formitem">
            {getFieldDecorator("pallet" + record.size, {
              rules: [
                { required: true, message: "Please input pallet value!" },
              ],
              initialValue: data,
            })(<Input />)}
          </Form.Item>
        ),
      },
      {
        title: "$/per yard",
        dataIndex: "yard",
        key: "yard",
        render: (data, record) => (
          <Form.Item className="Formitem">
            {getFieldDecorator("yard" + record.size, {
              rules: [{ required: true, message: "Please input yard value!" }],
              initialValue: data,
            })(<Input />)}
          </Form.Item>
        ),
      },
    ];

    const columns = [
      {
        title: "Location",
        dataIndex: "location",
        key: "location",
        align: "left",
        render: (location) => (
          <p style={{ color: "black", fontSize: "14px" }}>{location}</p>
        ),
      },
      {
        title: "Address",
        dataIndex: "address",
        key: "address",
        render: (address) => (
          <p style={{ color: "black", fontSize: "14px" }}>{address}</p>
        ),
      },
      {
        title: "Download",
        dataIndex: "download",
        key: "download",
        render: (_, record) => (
          <button onClick={() => this.downloadPriceSheet(record.location)}>
            Download
          </button>
        ),
      },

      {
        title: "",
        key: "ordermenu",
        render: (text, record) => (
          // record.isActive === false ? (
          <Dropdown.Button
            overlay={
              <Menu>
                <Menu.Item className="blue">
                  <Button
                    className="modalButton"
                    onClick={() => this.showLocationModal(record.key)}
                  >
                    Edit
                  </Button>
                  {/* <Button
                    className="modalButton"
                    // onClick={() => console.log(record.key)}
                    onClick={() => this.handleDelete(record.key)}
                  >
                    Delete
                  </Button> */}
                </Menu.Item>

                {/* <Menu.Item className="blue">
                    <Button
                      className="modalButton"
                      onClick={() => this.locationActive(record)}
                    >
                      Approve
                    </Button>
                  </Menu.Item> */}

                {/* <Menu.Item className="blue">
                  <Popconfirm
                    title="Sure to delete?"
                    onConfirm={() => this.handleDelete(record.key)}
                  >
                    <Button className="modalButton">Delete</Button>
                  </Popconfirm>
                </Menu.Item> */}
              </Menu>
            }
          ></Dropdown.Button>
        ),
        // ) : (
        //   <CheckOutlined style={{ color: "green", fontSize: "20px" }} />
        // ),
      },
      // {
      //   title: 'Address',
      //   dataIndex: 'address',
      //   key: 'address',
      //   render: (address, record) => (
      //     <span>
      //       {record["latLng"] &&
      //         <Link to={address} target="_blank" onClick={(event) => {event.preventDefault(); window.open('https://www.google.com/maps/dir/'+record["latLng"]["lat"]+","+record["latLng"]["lng"]);}} >
      //           Show on map
      //         </Link>
      //       }
      //     </span>
      //   )
      // },
      // {
      //   title: "",
      //   key: "ordermenu",
      //   render: (text, record) => (
      //     <Dropdown.Button
      //       overlay={
      //         <Menu>
      //           <Menu.Item className="blue">
      //             <Button
      //               className="modalButton"
      //               onClick={() => this.showLocationModal(record.key)}
      //             >
      //               Edit
      //             </Button>
      //           </Menu.Item>
      //           {record.isActive === false && (
      //             <Menu.Item className="blue">
      //               <Button
      //                 className="modalButton"
      //                 onClick={() => this.locationActive(record)}
      //               >
      //                 Active
      //               </Button>
      //             </Menu.Item>
      //           )}
      //           {/* <Menu.Item className='blue'>
      //                 <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record.key)}>
      //                   <Button className='modalButton'>
      //                     Delete
      //                   </Button>
      //                 </Popconfirm>
      //               </Menu.Item> */}
      //         </Menu>
      //       }
      //     ></Dropdown.Button>
      //   ),
      // },
    ];

    const ordersColumns = [
      {
        title: <div style={{ color: "grey" }}>Order#</div>,
        dataIndex: "orderId",
        key: "orderId",
        render: (id) => <div style={{ color: "black" }}>{id}</div>,
      },
      // {
      //   title: <div style={{ color: "grey" }}>Sub Order#</div>,
      //   dataIndex: "subOrderId",
      //   key: "subOrderId",
      //   render: (subOrderId, record) => (
      //     <div style={{ color: "black" }}>{subOrderId}</div>
      //   ),
      // },
      {
        title: <div style={{ color: "grey" }}>Product Name</div>,
        dataIndex: "productName",
        key: "productName",
        render: (productName) => (
          <div style={{ color: "black" }}>{productName}</div>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Order On</div>,
        dataIndex: "createdAt",
        key: "createdAt",
        render: (dateordered, record) => (
          <span>
            <div style={{ color: "black" }}>
              {moment(dateordered).format("MM/DD/YYYY")}
            </div>
            <div className="subtext" style={{ color: "grey" }}>
              {moment(dateordered).format("HH:mm")}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Status</div>,
        key: "orderStatus",
        dataIndex: "orderStatus",
        render: (tag, record) => (
          <span className="status_tag">
            <Tag
              color={AppConfigs["STATUS_COLORS"][tag]}
              style={{
                color: "black",
                height: "27px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {record["markAsInvoiced"]
                ? AppConfigs["DISPLAY_LEAD_STATUS"]["admin"]["INV"]
                : record["markAsPaid"]
                ? AppConfigs["DISPLAY_LEAD_STATUS"]["admin"]["PAID"]
                : AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][tag]}
            </Tag>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Location</div>,
        dataIndex: "location",
        key: "location",
        width: "150px",
        sorter: true,
        render: (location, record) => (
          <span>
            <div style={{ color: "black" }}>
              {record["cartItems"][0]["locationName"]}
            </div>
            <div className="subtext" style={{ color: "grey" }}>
              {record.address
                ? record["cartItems"][0]["address"].split(",").length > 0
                  ? record["cartItems"][0]["address"].split(",")[1] +
                    ", " +
                    record["cartItems"][0]["address"].split(",")[2]
                  : record.address
                : ""}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Delivery Date</div>,
        dataIndex: "deliveryDateAndTime",
        key: "deliveryDateAndTime",
        render: (deliveryDateAndTime) => (
          <span>
            <div style={{ color: "black" }}>
              {deliveryDateAndTime &&
                moment(deliveryDateAndTime).format("MM/DD/YYYY")}
            </div>
            <div className="subtext" style={{ color: "grey" }}>
              {deliveryDateAndTime &&
                moment(deliveryDateAndTime).format("hh:mm A")}
            </div>
          </span>
        ),
      },
    ];

    const pricesheetColumns = [
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Item #
          </div>
        ),
        dataIndex: "productCode",
        className: "list-data tableSizes-item",
        key: "productCode",
        align: "left",
        render: (data) => <div style={{ color: "black" }}>{data}</div>,
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Photos
          </div>
        ),
        dataIndex: "image",
        className: "list-data tableSizes-photo",
        key: "image",
        align: "left",
        render: (data) => (
          <img
            src={data}
            style={{ width: "75px", height: "75px", borderRadius: "10px" }}
            alt="product icon"
          />
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Item Name
          </div>
        ),
        dataIndex: "productName",
        className: "list-data tableSizes-itemName",
        key: "productName",
        align: "left",
        render: (data) => <div style={{ color: "black" }}>{data}</div>,
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Size
          </div>
        ),
        dataIndex: "sizes",
        width: "100px",
        className: "list-data tableSizes-size",
        key: "sizes",
        align: "left",
        render: (sizes, data) => (
          <div style={{ color: "black" }}>
            {sizes && sizes.length > 0 ? (
              sizes.map(
                (size) => (
                  // size.location === selectLocation && (
                  <Input
                    value={size.size}
                    disabled={true}
                    className="size-edit-disable"
                  />
                )
                // )
              )
            ) : (
              <Input disabled={true} className="size-edit-disable" />
            )}
          </div>
        ),
      },
      // {
      //   title: (
      //     <div className="list-head" style={{ color: "grey" }}>
      //       Cost
      //     </div>
      //   ),
      //   dataIndex: "sizes",
      //   className: "list-data tableSizes-size",
      //   key: "baseCost",
      //   align: "left",
      //   sorter: true,
      //   render: (sizes, data) => (
      //     <div style={{ color: "black" }}>
      //       {sizes &&
      //         sizes.map((size) => (
      //           <Input
      //             value={size.baseCost}
      //             className="size-edit-disable"
      //             disabled={true}
      //           />
      //         ))}
      //     </div>
      //   ),
      // },
      // {
      //   title: (
      //     <div className="list-head" style={{ color: "grey" }}>
      //       Margin
      //     </div>
      //   ),
      //   dataIndex: "sizes",
      //   className: "list-data tableSizes-size",
      //   key: "sizes-margin",
      //   align: "left",
      //   sorter: true,
      //   render: (sizes, data) => (
      //     <div style={{ color: "black" }}>
      //       {sizes &&
      //         sizes.map((size) => (
      //           <Input
      //             value={size.marginPrice}
      //             className="size-edit-disable"
      //             disabled={true}
      //           />
      //         ))}
      //     </div>
      //   ),
      // },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Price
          </div>
        ),
        dataIndex: "sizes",
        className: "list-data tableSizes-ton",
        key: "price",
        align: "left",
        width: "100px",
        render: (sizes, data) => (
          <div style={{ color: "black" }}>
            {sizes && sizes.length > 0 ? (
              sizes.map((size, index) => (
                <>
                  {this.state.deliveryEdit === data.id ? (
                    <Input
                      value={
                        index === this.state.price.key
                          ? this.state.price.value
                          : size.price
                        // ? size.price
                        // : "0.0"
                      }
                      className="size-edit"
                      onChange={(e) =>
                        this.handleInputChange(
                          e.target.value,
                          "price",
                          index,
                          data.id,
                          size
                        )
                      }
                    />
                  ) : (
                    <Input
                      value={size.price}
                      className="size-edit-disable"
                      disabled={true}
                    />
                  )}
                </>
              ))
            ) : (
              <>
                {this.state.deliveryEdit === data.id ? (
                  <Input
                    // value={
                    //   index === this.state.price.key
                    //     ? this.state.price.value
                    //     : selectLocation === size.location
                    //     ? size.price
                    //     : "0.0"
                    // }
                    className="size-edit"
                    onChange={(e) =>
                      this.handleInputChange(
                        e.target.value,
                        "price",
                        0,
                        data.id,
                        []
                      )
                    }
                  />
                ) : (
                  <Input className="size-edit-disable" disabled={true} />
                )}
              </>
            )}
          </div>
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Update
          </div>
        ),
        dataIndex: "sizes",
        className: "list-data tableSizes-update",
        key: "update",
        align: "left",
        render: (sizes, data) => (
          <>
            {this.state.showSaveIcon && this.state.deliveryEdit === data.id ? (
              <>
                <CheckOutlined
                  onClick={() => this.saveSizechanges(data.id, "price")}
                  style={{
                    color: "green",
                    marginRight: "20px",
                    fontSize: "1.4em",
                  }}
                />
                <CloseOutlined
                  onClick={this.cancelPriceSheet}
                  style={{ fontSize: "1.4em", color: "red" }}
                />
              </>
            ) : (
              <EditOutlined
                title="edit"
                onClick={() =>
                  data.isActive === true && this.deliveryEdit(data.id)
                }
                style={{
                  fontSize: "1.4em",
                  cursor: data.isActive === true ? "pointer" : "not-allowed",
                }}
              />
            )}
          </>
        ),
      },

      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Active
          </div>
        ),
        dataIndex: "sizes",
        className: "list-data tableSizes-status",
        key: "status",
        align: "left",
        render: (sizes, data) => (
          <>
            {sizes[0].price !== "0" && data.isActive === true && (
              <>
                <Switch
                  defaultChecked={true}
                  checkedChildren={"Yes"}
                  unCheckedChildren={"No"}
                  onChange={(e) => this.handleStatus(data.id, e)}
                />
              </>
            )}
            {(sizes[0].price === "0" || data.isActive === false) && (
              <>
                <Switch
                  defaultChecked={false}
                  checkedChildren={"Yes"}
                  unCheckedChildren={"No"}
                  onChange={(e) => this.handleStatus(data.id, e)}
                />
              </>
            )}
          </>
        ),
      },
    ];

    const palletpricesheetColumns = [
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Item #
          </div>
        ),
        dataIndex: "productCode",
        className: "list-data tableSizes-item",
        key: "productCode",
        align: "left",
        sorter: true,
        render: (data) => <div style={{ color: "black" }}>{data}</div>,
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Photos
          </div>
        ),
        dataIndex: "image",
        className: "list-data tableSizes-photo",
        key: "image",
        align: "left",
        render: (data) => (
          <img
            src={data}
            style={{ width: "75px", height: "75px", borderRadius: "10px" }}
            alt="product icon"
          />
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Item Name
          </div>
        ),
        dataIndex: "productName",
        className: "list-data tableSizes-itemName",
        key: "productName",
        align: "left",
        sorter: true,
        render: (data) => <div style={{ color: "black" }}>{data}</div>,
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Size
          </div>
        ),
        dataIndex: "sizes",
        className: "list-data tableSizes-size",
        key: "sizes",
        align: "left",
        sorter: true,
        render: (sizes, data) => (
          <div style={{ color: "black" }}>
            {sizes &&
              sizes.map((size) => (
                <Input
                  value={size && size.size}
                  disabled={true}
                  className="size-edit-disable"
                />
              ))}
          </div>
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Weight
          </div>
        ),
        dataIndex: "sizes",
        className: "list-data tableSizes-ton",
        key: "sizes",
        align: "left",
        sorter: true,
        render: (sizes, data) => (
          <div style={{ color: "black" }}>
            {sizes &&
              sizes.map((size, index) => (
                <>
                  {this.state.deliveryEdit === data.id ? (
                    <Select
                      className="size-edit-disable"
                      onChange={(e) =>
                        this.handleInputChange(
                          e,
                          "weight",
                          index,
                          data.id,
                          size
                        )
                      }
                      style={{ width: "100px" }}
                    >
                      <Option value="1 Ton">1 Ton</Option>
                      <Option value="1.5 Ton"> 1.5 Ton</Option>
                    </Select>
                  ) : (
                    <Input
                      value={size && size.ton}
                      className="size-edit-disable"
                      disabled={true}
                    />
                  )}
                </>
              ))}
          </div>
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Price
          </div>
        ),
        dataIndex: "sizes",
        className: "list-data tableSizes-pallet",
        key: "sizes",
        align: "left",
        sorter: true,
        render: (sizes, data) => (
          <div style={{ color: "black" }}>
            {sizes &&
              sizes.map((size, index) => (
                <>
                  {this.state.deliveryEdit === data.id ? (
                    <Input
                      value={
                        index === this.state.pallet.key
                          ? this.state.pallet.value
                          : selectLocation === size.location && size.price
                      }
                      className="size-edit"
                      onChange={(e) =>
                        this.handleInputChange(
                          e.target.value,
                          "pallet",
                          index,
                          data.id,
                          size
                        )
                      }
                    />
                  ) : (
                    <Input
                      value={size && size.price}
                      className="size-edit-disable"
                      disabled={true}
                    />
                  )}
                </>
              ))}
          </div>
        ),
      },
      // {
      //   title: (
      //     <div className="list-head" style={{ color: "grey" }}>
      //       Update
      //     </div>
      //   ),
      //   dataIndex: "sizes",
      //   className: "list-data tableSizes-update",
      //   key: "sizes",
      //   align: "left",
      //   sorter: true,
      //   render: (sizes, data) => (
      //     <>
      //       {this.state.showSaveIcon && this.state.deliveryEdit === data.id ? (
      //         <>
      //           <CheckOutlined
      //             onClick={() => this.saveSizechanges(data.id, "pallet")}
      //             style={{
      //               color: "green",
      //               marginRight: "20px",
      //               fontSize: "1.4em",
      //             }}
      //           />
      //           <CloseOutlined
      //             onClick={this.cancelPriceSheet}
      //             style={{ fontSize: "1.4em", color: "red" }}
      //           />
      //         </>
      //       ) : (
      //         <EditOutlined
      //           title="edit"
      //           onClick={() => this.deliveryEdit(data.id)}
      //           style={{ fontSize: "1.4em" }}
      //         />
      //       )}
      //     </>
      //   ),
      // },
    ];

    const subUserColumns = [
      {
        title: <div style={{ color: "gray" }}>Full Name</div>,
        dataIndex: "firstName",
        key: "firstName",
        render: (firstName, record) => (
          <span style={{ color: "black" }}>
            {firstName + " " + record.lastName}
          </span>
        ),
      },
      // {
      //   title: <div style={{ color: "gray" }}>Phone</div>,
      //   dataIndex: "phone",
      //   key: "phone",
      //   render: (phone) => (
      //     <div style={{ color: "black" }}>
      //       <span>{phone}</span>
      //     </div>
      //   ),
      // },
      {
        title: <div style={{ color: "gray" }}>Email</div>,
        dataIndex: "email",
        key: "email",
        render: (email) => (
          <span>
            <div style={{ color: "black" }}>{email}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>UserProfile</div>,
        dataIndex: "userProfile",
        key: "userProfile",
        render: (userProfile) => (
          <span>
            <div style={{ color: "black" }}>
              {userProfile === "SCU" ? "Sub User" : "Customeradmin"}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Status</div>,
        dataIndex: "isActive",
        key: "isActive",
        render: (isActive) => (
          <span>
            <div style={{ color: "black" }}>
              {isActive === true ? "Active" : "Inactive"}
            </div>
          </span>
        ),
      },

      {
        title: "",
        key: "id",
        dataIndex: "id",
        render: (id, record) => (
          <Dropdown.Button
            overlay={
              <Menu>
                <Menu.Item className="blue">
                  <Button
                    className="modalButton"
                    onClick={() => this.showSubUserEditModal(id)}
                  >
                    Edit
                  </Button>
                </Menu.Item>
                <Menu.Item className="blue">
                  {record?.isActive ? (
                    <Button
                      className="modalButton"
                      onClick={() => this.changeSubCustomerStatus(false, id)}
                    >
                      Inactive
                    </Button>
                  ) : (
                    <Button
                      className="modalButton"
                      onClick={() => this.changeSubCustomerStatus(true, id)}
                    >
                      Active
                    </Button>
                  )}
                </Menu.Item>
              </Menu>
            }
          ></Dropdown.Button>
        ),
      },
    ];

    if (
      this.state.userDetails.userProfile !== "A" &&
      this.state.userDetails.userProfile !== "M"
    ) {
      return <ErrorPage />;
    }

    return (
      <div style={{ position: "absolute", top: "135px", width: "100%" }}>
        <Row style={{ margin: "20px" }}>
          <Menu
            mode="horizontal"
            style={{ backgroundColor: "rgb(14, 77, 144)", color: "white" }}
          >
            <Menu.Item key="1">
              <Link to="/app/customers">
                <h3 style={{ color: "#fff" }}>
                  <ArrowLeftOutlined style={{ fontSize: "1em" }} />
                  Back to list
                </h3>
              </Link>
            </Menu.Item>

            <Menu.Item key="2" style={{ cursor: "default" }}>
              <h2 style={{ color: "#fff" }}>Customer Details</h2>
            </Menu.Item>

            <Menu.Item key="3" style={{ cursor: "default" }}>
              <h3 style={{ color: "#fff" }}>
                STATUS :
                {
                  <span className="status_tag">
                    &nbsp;
                    <Tag
                      color={
                        this.state.customerInfo["approvalStatus"] === "A"
                          ? "green"
                          : this.state.customerInfo["approvalStatus"] === "P"
                          ? "yellow"
                          : this.state.customerInfo["approvalStatus"] === "F"
                          ? "blue"
                          : "red"
                      }
                      key={this.state.customerInfo["approvalStatus"]}
                      style={{
                        color: "black",
                        height: "27px",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      {
                        AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][
                          this.state.customerInfo["approvalStatus"]
                        ]
                      }
                    </Tag>
                  </span>
                }
              </h3>
            </Menu.Item>

            {this.state.customerInfo["approvalStatus"] === "A" && (
              <Menu.Item key="4" style={{ cursor: "default" }}>
                <h3
                  style={{
                    color: "#fff",
                    fontSize: "18px",
                    background: "#0e4d90",
                  }}
                >
                  Credit limit :{" "}
                  <NumberFormat
                    value={parseFloat(
                      this.state.customerInfo["creditAmount"]
                    ).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                  <EditOutlined
                    key="edit"
                    onClick={() => {
                      this.setState({
                        creditAmtUpdate: true,
                        customerApproval: true,
                      });
                    }}
                    style={{ fontSize: "1.4em" }}
                  />
                </h3>
              </Menu.Item>
            )}

            {this.state.customerInfo["approvalStatus"] === "A" && (
              <Menu.Item key="5" style={{ cursor: "default" }}>
                <h3
                  style={{
                    color: "#fff",
                    fontSize: "18px",
                    background: "#0e4d90",
                  }}
                >
                  Available Credit :{" "}
                  <NumberFormat
                    value={parseFloat(
                      this.state.customerInfo["presentCreditAmount"]
                    ).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </h3>
              </Menu.Item>
            )}

            {this.state.customerInfo["approvalStatus"] === "A" && (
              <>
                <Menu.Item
                  key="10"
                  style={{ float: "right", background: "#0e4d90" }}
                >
                  {this.state.freezeAccountLoading ? (
                    <Button key="submit" className="assigning">
                      <SyncOutlined spin />
                      Freeze Account
                    </Button>
                  ) : (
                    <Button
                      key="submit"
                      htmlType="submit"
                      className="assigning"
                      onClick={() => {
                        this.changeCustomerStatus(
                          "F",
                          false,
                          "freezeAccountLoading",
                          parseFloat(
                            this.state.customerInfo["presentCreditAmount"]
                          ).toFixed(2)
                        );
                      }}
                    >
                      <CheckOutlined />
                      Freeze Account
                    </Button>
                  )}
                </Menu.Item>
              </>
            )}

            <Menu.Item
              key="12"
              style={{ float: "right", marginTop: "5px" }}
              className="downArrow"
            >
              <Dropdown overlay={menu}>
                <DownOutlined style={{ fontSize: "18px", color: "#fff" }} />
              </Dropdown>
            </Menu.Item>

            <Menu.Item
              key="6"
              onClick={this.showLoginModal}
              style={{
                float: "right",
              }}
            >
              <h3 style={{ color: "#fff" }}>
                <UserOutlined style={{ fontSize: "1.2em" }} />
                LOGIN DETAILS
              </h3>
            </Menu.Item>
            {this.state.customerInfo["approvalStatus"] !== "D" && (
              <Menu.Item key="7" style={{ float: "right" }}>
                <Popconfirm
                  title="Do you want to email the price sheet to the customer?"
                  onConfirm={() => {
                    this.setState({ pricesheetModal: true });
                  }}
                  onCancel={this.cancel}
                  okText="Yes"
                  cancelText="No"
                >
                  <h3 style={{ color: "#fff" }}>SEND PRICE SHEET</h3>
                </Popconfirm>
              </Menu.Item>
            )}

            {this.state.customerInfo["approvalStatus"] === "P" &&
              this.state.userDetails &&
              this.state.userDetails.userProfile === "A" && (
                <Menu.Item
                  key="9"
                  style={{
                    borderRight: "1px solid #A2AABD",
                    background: "#0e4d90",
                    float: "right",
                  }}
                >
                  <h3 style={{ color: "#fff" }}>
                    {this.state.approveLoading ? (
                      <Button
                        style={{
                          background: "green",
                          borderColor: "green",
                          color: "#FFF",
                        }}
                      >
                        <SyncOutlined spin />
                        Approve
                      </Button>
                    ) : (
                      <Button
                        style={{
                          background: "green",
                          borderColor: "green",
                          color: "#FFF",
                        }}
                        onClick={() => {
                          this.setState({
                            creditAmtUpdate: false,
                            customerApproval: true,
                          });
                        }}
                      >
                        <CheckOutlined />
                        Approve
                      </Button>
                    )}
                  </h3>
                </Menu.Item>
              )}
            {this.state.customerInfo["approvalStatus"] === "P" &&
              this.state.userDetails &&
              this.state.userDetails.userProfile === "A" && (
                <Menu.Item key="8" style={{ float: "right" }}>
                  <h3 style={{ color: "#fff" }}>
                    {this.state.declineLoading ? (
                      <Button style={{ color: "black" }}>
                        <SyncOutlined spin />
                        Decline
                      </Button>
                    ) : (
                      <Button
                        style={{ color: "black" }}
                        onClick={() => {
                          this.changeCustomerStatus(
                            "D",
                            false,
                            "declineLoading"
                          );
                        }}
                      >
                        <StopOutlined />
                        Decline
                      </Button>
                    )}
                  </h3>
                </Menu.Item>
              )}
            {(this.state.customerInfo["approvalStatus"] === "D" ||
              this.state.customerInfo["approvalStatus"] === "F") && (
              <Menu.Item
                key="10"
                style={{ float: "right", borderRight: "1px solid #A2AABD" }}
              >
                <h3 style={{ color: "#fff" }}>
                  {this.state.approveLoading ? (
                    <Button
                      style={{
                        background: "green",
                        borderColor: "green",
                        color: "#FFF",
                      }}
                    >
                      <SyncOutlined spin />
                      Activate
                    </Button>
                  ) : (
                    <Button
                      style={{
                        background: "green",
                        borderColor: "green",
                        color: "#FFF",
                        fontWeight: "bold",
                      }}
                      onClick={() => {
                        this.setState({
                          creditAmtUpdate: false,
                          customerApproval: true,
                        });
                      }}
                    >
                      <CheckOutlined />
                      Activate
                    </Button>
                  )}
                </h3>
              </Menu.Item>
            )}
          </Menu>
        </Row>
        <Row gutter={16} style={{ margin: "40px 20px" }}>
          <Col lg={6} md={6} sm={24} xs={24}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <div className="site-card-border-less-wrapper">
                <Card
                  title="Customer Details"
                  extra={
                    rolePermisions &&
                    rolePermisions[0]?.permissions?.includes(
                      "editCustomer"
                    ) && (
                      <EditOutlined
                        key="edit"
                        onClick={this.showProfileModal}
                        style={{ fontSize: "1.4em" }}
                      />
                    )
                  }
                  style={{ borderRadius: "10px" }}
                >
                  <Row>
                    <Col xl={8} lg={24} md={24} sm={24} xs={24}>
                      <Text disabled>Company</Text>
                    </Col>
                    <Col xl={16} lg={24} md={24} sm={24} xs={24}>
                      <Text>{this.state.customerInfo["companyName"]}</Text>
                    </Col>
                    <Divider />
                    <Col
                      xl={8}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "3%" }}
                    >
                      <Text disabled>Customer Name</Text>
                    </Col>
                    <Col
                      xl={16}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "3%" }}
                    >
                      <Text>
                        {this.state?.loginDetails?.["firstName"] +
                          " " +
                          this.state?.loginDetails?.["lastName"]}
                      </Text>
                      {/* <Text>Test</Text> */}
                    </Col>
                    <Divider />
                    <Col
                      xl={8}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "3%" }}
                    >
                      <Text disabled>Phone</Text>
                    </Col>
                    <Col
                      xl={16}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "3%" }}
                    >
                      <Text>
                        {formatPhoneNumber(this.state.customerInfo["phone"])}
                      </Text>
                    </Col>
                    <Divider />
                    <Col
                      xxl={8}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "3%" }}
                    >
                      <Text disabled>Email</Text>
                    </Col>
                    <Col
                      xxl={16}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "3%" }}
                    >
                      <a
                        type="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={"mailto:" + this.state.customerInfo["email"]}
                        style={{
                          color: "#000000a6",
                        }}
                      >
                        {this.state.customerInfo["email"]}
                      </a>
                    </Col>
                    <Divider />
                    <Col
                      xl={8}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "3%" }}
                    >
                      <Text disabled>Address</Text>
                    </Col>
                    <Col
                      xl={16}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "3%" }}
                    >
                      <Text>{this.state.customerInfo["address"]}</Text>
                    </Col>
                  </Row>
                </Card>
              </div>
            </Col>

            <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: "4%" }}>
              <div className="site-card-border-less-wrapper">
                <Card
                  title="Notes"
                  extra={
                    rolePermisions &&
                    rolePermisions[0]?.permissions?.includes("editCustomer") &&
                    this.state?.loginDetails?.["richTextEditior"] ? (
                      <EditOutlined
                        key="edit"
                        onClick={() => this.showTextModal("Edit Note")}
                        style={{ fontSize: "1.4em" }}
                      />
                    ) : (
                      <span
                        onClick={() => this.showTextModal("Add Note")}
                        style={{ cursor: "pointer" }}
                      >
                        <Button
                          type="dashed"
                          style={{
                            textAlign: "center",
                            backgroundColor: "#0E4D90",
                            width: "20px",
                            borderRadius: "50%",
                            borderColor: "#0E4D90",
                            padding: "0px",
                            height: "20px",
                          }}
                        >
                          <Icon
                            type="plus"
                            style={{
                              verticalAlign: "0px",
                              fontSize: "12px",
                              color: "white",
                            }}
                          />
                        </Button>
                        &nbsp;<span>Add Note</span>
                      </span>
                    )
                  }
                  style={{ borderRadius: "10px" }}
                >
                  <Row>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${
                            this.state?.loginDetails &&
                            this.state?.loginDetails?.["richTextEditior"]
                              ? this.state?.loginDetails?.["richTextEditior"]
                              : ""
                          }`,
                        }}
                      />
                    </Col>
                  </Row>
                </Card>
              </div>
            </Col>
            <Col
              lg={24}
              md={24}
              sm={24}
              xs={24}
              style={{ marginTop: "4%", paddingLeft: "4px" }}
            >
              <div className="site-card-border-less-wrapper">
                <Card
                  title="Documents"
                  extra={
                    rolePermisions &&
                    rolePermisions[0]?.permissions?.includes(
                      "editCustomer"
                    ) && (
                      // <Link to="/app/editdocuments">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => this.showDocumentModal("Add Document")}
                      >
                        <Button
                          type="dashed"
                          style={{
                            textAlign: "center",
                            backgroundColor: "#0E4D90",
                            width: "20px",
                            borderRadius: "50%",
                            borderColor: "#0E4D90",
                            padding: "0px",
                            height: "20px",
                          }}
                        >
                          <Icon
                            type="plus"
                            style={{
                              verticalAlign: "0px",
                              fontSize: "12px",
                              color: "white",
                            }}
                          />
                        </Button>
                        &nbsp;<span>Add Documents</span>
                      </span>
                      // </Link>
                    )
                  }
                  style={{ borderRadius: "10px" }}
                >
                  <Row gutter={16}>
                    {this.state.customerInfo &&
                      this.state.customerInfo["customerDocuments"] &&
                      this.state.customerInfo["customerDocuments"]["creditApp"]
                        ?.length > 0 && (
                        <Col
                          lg={8}
                          md={8}
                          sm={24}
                          xs={24}
                          className="credit-app-doc"
                        >
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.fileDownload(
                                this.state.customerInfo["customerDocuments"][
                                  "creditApp"
                                ][0],
                                "CreditApp",
                                this.state.customerInfo["companyName"]
                              );
                            }}
                          >
                            <img src={Docsample} alt="Doc" />
                            <h4
                              style={{
                                color: "#7B8190",
                                fontSize: "13px",
                                textAlign: "center",
                              }}
                            >
                              Credit App
                            </h4>
                          </span>
                          <span>
                            {" "}
                            <Popconfirm
                              title="Are you sure you want to delete this document?"
                              onConfirm={() => this.deleteDocument("creditApp")}
                              style={{ width: "100px" }}
                            >
                              <DeleteOutlined
                                style={{ color: "#7b8090", fontSize: "1.3em" }}
                                title="Delete"
                              />
                            </Popconfirm>
                          </span>
                        </Col>
                      )}
                    {this.state.customerInfo &&
                      this.state.customerInfo["customerDocuments"] &&
                      this.state.customerInfo["customerDocuments"]["rc"]
                        ?.length > 0 && (
                        <Col
                          lg={8}
                          md={8}
                          sm={24}
                          xs={24}
                          className="credit-app-doc"
                        >
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.fileDownload(
                                this.state.customerInfo["customerDocuments"][
                                  "rc"
                                ][0],
                                "ResaleCertificate",
                                this.state.customerInfo["companyName"]
                              );
                            }}
                          >
                            <img src={Docsample} alt="Doc" />
                            <h4
                              style={{
                                color: "#7B8190",
                                fontSize: "13px",
                                textAlign: "center",
                              }}
                            >
                              Resale Certificate
                            </h4>
                          </span>
                          <span>
                            <Popconfirm
                              title="Are you sure you want to delete this document?"
                              onConfirm={() => this.deleteDocument("rc")}
                            >
                              <DeleteOutlined
                                style={{ color: "#7b8090", fontSize: "1.3em" }}
                                title="Delete"
                              />
                            </Popconfirm>
                          </span>
                        </Col>
                      )}
                  </Row>
                </Card>
              </div>
            </Col>
            <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: "4%" }}>
              <div className="site-card-border-less-wrapper">
                <Card
                  title="Locations"
                  extra={
                    rolePermisions &&
                    rolePermisions[0]?.permissions?.includes(
                      "editCustomer"
                    ) && (
                      <span
                        onClick={this.addlocation}
                        style={{ cursor: "pointer" }}
                      >
                        <Button
                          type="dashed"
                          style={{
                            textAlign: "center",
                            backgroundColor: "#0E4D90",
                            width: "20px",
                            borderRadius: "50%",
                            borderColor: "#0E4D90",
                            padding: "0px",
                            height: "20px",
                          }}
                        >
                          <Icon
                            type="plus"
                            style={{
                              verticalAlign: "0px",
                              fontSize: "12px",
                              color: "white",
                            }}
                          />
                        </Button>
                        &nbsp;<span>Add Location</span>
                      </span>
                    )
                  }
                >
                  <div className="trucktable">
                    <div
                      className="orders"
                      style={{ padding: "0px", margin: "0px" }}
                    >
                      <Table
                        columns={columns}
                        dataSource={this.state.locations}
                        pagination={false}
                        style={{ overflowX: "auto" }}
                      />
                    </div>
                  </div>
                </Card>
              </div>
            </Col>
          </Col>
          <Col lg={18} md={18} sm={24} xs={24}>
            <div
              className="site-card-border-less-wrapper"
              style={{ borderRadius: "10px" }}
            >
              <Tabs
                defaultActiveKey="1"
                className="ant-card"
                style={{ borderRadius: "10px" }}
                onChange={this.handleTabChange}
              >
                <TabPane
                  tab={
                    <h3>
                      <b>Bulk Price Sheet</b>
                    </h3>
                  }
                  key="1"
                >
                  <div style={{ marginTop: "1vw" }}>
                    <Row className="customer-price-sheet-section">
                      <Col span={12}>
                        <Tabs
                          className="stones-tab"
                          onChange={this.handleLocations}
                          type="card"
                        >
                          {locations.map(
                            (l) =>
                              l.isActive !== false && (
                                <TabPane
                                  tab={l.location}
                                  key={l.location}
                                ></TabPane>
                              )
                          )}
                        </Tabs>

                        {/* <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "black",
                            marginLeft: "10px",
                            marginRight: "10px",
                          }}
                        >
                          Location
                        </span>
                        <Select
                          style={{
                            width: "25%",
                            marginBottom: "1vw",
                          }}
                          onChange={this.handleLocations}
                          value={`${selectLocation}`}
                        >
                          {locations.map(
                            (l) =>
                              l.isActive !== false && (
                                <Select.Option key={l.value} value={l.location}>
                                  {l.location}
                                </Select.Option>
                              )
                          )}
                        </Select> */}
                      </Col>
                      <Col span={12} style={{ textAlign: "right" }}>
                        {/* Make a button that says Download Price Sheet  */}
                        <Button
                          type="primary"
                          icon={<DownloadOutlined />}
                          size="large"
                          style={{ margin: "10px" }}
                          onClick={() => {
                            this.downloadPriceSheet();
                          }}
                        >
                          Download Price Sheet
                        </Button>
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "black",
                            marginLeft: "10px",
                            marginRight: "10px",
                          }}
                          className="price-increment-title"
                        >
                          Price Increment
                        </span>
                        <Input
                          type="tel"
                          value={this.state.increaseVal}
                          onChange={(e) => this.updateNumber(e, "increaseVal")}
                          pattern="^-?[0-9]\d*\.?\d*$"
                          placeholder="Input a number"
                          style={{
                            width: "25%",
                            height: "32px",
                          }}
                          className="price-increment-input"
                          prefix={"$"}
                          suffix={"%"}
                          readOnly={this.state.isCheckingPrices ? true : false}
                        />
                        {!this.state.isCheckingPrices ? (
                          <Button
                            loading={this.state.loading}
                            className="settings-save-btn"
                            style={{
                              // background: "#0e4d90",
                              borderColor: "#0e4d90",
                              margin: "0px",
                              marginLeft: "10px",
                              marginRight: "10px",
                              height: "32px",
                            }}
                            onClick={() =>
                              this.calculateCustomerPrice(
                                this.state.bulkData.length > 0 &&
                                  this.state.bulkData[0].productCategory,
                                "bulk",
                                selectLocation
                              )
                            }
                          >
                            Check
                          </Button>
                        ) : (
                          <>
                            <Button
                              loading={this.state.loading}
                              className="settings-save-btn"
                              style={{
                                // background: "#0e4d90",
                                borderColor: "#0e4d90",
                                margin: "0px",
                                marginLeft: "10px",
                                marginRight: "10px",
                                height: "32px",
                              }}
                              onClick={() =>
                                this.updateCustomerPrice(
                                  this.state.bulkData.length > 0 &&
                                    this.state.bulkData[0].productCategory,
                                  "bulk",
                                  selectLocation
                                )
                              }
                            >
                              Update
                            </Button>
                            <Button
                              className="settings-save-btn"
                              style={{
                                // background: "#0e4d90",
                                borderColor: "#0e4d90",
                                color: "#0e4d90",
                                margin: "0px",
                                marginLeft: "10px",
                                marginRight: "10px",
                                height: "32px",
                              }}
                              onClick={() => {
                                this.cancelPriceUpdate();
                              }}
                            >
                              Cancel
                            </Button>
                          </>
                        )}
                      </Col>
                    </Row>

                    <Table
                      style={{ overflowX: "auto" }}
                      columns={pricesheetColumns}
                      dataSource={this.state.bulkData}
                      loading={this.state.dataLoadingStatus}
                      rowKey={(record) => record.id}
                      rowClassName={(record) =>
                        !record.isActive && "disabled-row"
                      }
                      pagination={{
                        defaultPageSize: 10,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "25", "50", "100"],
                        total: this.state.bulkData.length,
                        showTotal: showTotal,
                      }}
                    />
                  </div>
                </TabPane>

                <TabPane
                  tab={
                    <h3>
                      <b>Pallet Price Sheet</b>
                    </h3>
                  }
                  key="2"
                >
                  <div style={{ marginTop: "1vw" }}>
                    <Row
                      style={{
                        marginBottom: "1vw",
                      }}
                    >
                      <Col
                        span={12}
                        offset={12}
                        style={{ textAlign: "right" }}
                        className="delivery-fee"
                      >
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "black",
                            marginLeft: "10px",
                            marginRight: "10px",
                          }}
                        >
                          Delivery Fee
                        </span>
                        <Input
                          type="tel"
                          defaultValue={this.state.deliveryFee}
                          onChange={(e) => this.updateNumber(e, "delivery")}
                          pattern="^-?[0-9]\d*\.?\d*$"
                          placeholder="Input a number"
                          style={{
                            width: "25%",
                            height: "32px",
                          }}
                          prefix={"$"}
                        />

                        <Button
                          loading={this.state.loading}
                          className="settings-save-btn"
                          style={{
                            background: "#0e4d90",
                            borderColor: "#0e4d90",
                            margin: "0px",
                            marginLeft: "10px",
                            marginRight: "10px",
                            height: "32px",
                          }}
                          onClick={this.updateDeliveryFee}
                        >
                          Update
                        </Button>
                      </Col>
                    </Row>
                    <Table
                      style={{ overflowX: "auto" }}
                      columns={palletpricesheetColumns}
                      dataSource={this.state.palletData?.filter(
                        (active) => active.isActive !== false
                      )}
                      loading={this.state.dataLoadingStatus}
                      rowKey={(record) => record.id}
                      pagination={{
                        defaultPageSize: 10,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "25", "50", "100"],
                        total: this.state.palletData?.filter(
                          (active) => active.isActive !== false
                        ).length,
                        showTotal: showTotal,
                      }}
                    />
                  </div>
                </TabPane>
                <TabPane
                  tab={
                    <h3>
                      <b>Orders</b>
                    </h3>
                  }
                  key="3"
                >
                  <div style={{ marginTop: "20px" }}>
                    <Table
                      style={{ overflowX: "auto" }}
                      columns={ordersColumns}
                      dataSource={this.state.loadsList}
                      loading={this.state.dataLoadingStatus}
                      rowKey={(record) => record.id}
                      pagination={{
                        defaultPageSize: 10,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "25", "50", "100"],
                        total: this.state.loadsList.length,
                        showTotal: showTotal,
                      }}
                      onRow={(record) => ({
                        onClick: () =>
                          (window.location =
                            "/app/loads/loaddetails/" + record.id),
                        style: { cursor: "pointer" },
                      })}
                    />
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </Col>
          <Col lg={6} md={6} sm={24} xs={24}></Col>
          <Col lg={18} md={18} sm={24} xs={24} style={{ marginTop: "1%" }}>
            <div className="site-card-border-less-wrapper">
              <Card
                title="SubUser"
                style={{ borderRadius: "10px" }}
                // extra={
                //   rolePermisions &&
                //   rolePermisions[0]?.permissions?.includes(
                //     "editCarrier"
                //   ) && (
                //     <Button
                //       size="large"
                //       onClick={this.addDriver}
                //       className="submit-btn"
                //     >
                //       Add Driver
                //     </Button>
                //   )
                // }
              >
                <div className="trucktable">
                  <div
                    className="orders"
                    style={{ padding: "0px", margin: "0px" }}
                  >
                    <Table
                      columns={subUserColumns}
                      dataSource={this.state.subUserList}
                      loading={this.state.dataLoading}
                      rowKey={(record) => record.id}
                    />
                  </div>
                </div>
              </Card>
            </div>
          </Col>
          <Col lg={6} md={6} sm={24} xs={24}></Col>
          <Col lg={18} md={18} sm={24} xs={24}>
            <div
              className="site-card-border-less-wrapper"
              style={{ borderRadius: "10px", marginTop: "1vw" }}
            >
              <Card
                title="Customer Audit Trail"
                style={{ borderRadius: "10px" }}
              >
                <Row gutter={16}>
                  <Table
                    columns={auditColumns}
                    dataSource={customerAuditDetails}
                    size="middle"
                  />
                  {/* {customerAuditDetails.length > 0 &&
                    customerAuditDetails.map((eachAudit) => (
                      <>
                        <Col>
                          <h2>
                            {eachAudit.firstName + " " + eachAudit.lastName}
                          </h2>
                          {eachAudit.auditTrailDetails.length > 0 &&
                            eachAudit.auditTrailDetails.map((changes) => (
                              <>
                                <div
                                
                                className="ant-table-column-title"
                                >
                                  {changes.oldFields} changes to {" "}
                                  {changes.modifiedField}
                                </div>
                              </>
                            ))}
                        </Col>
                      </>
                    ))} */}
                </Row>
              </Card>
            </div>
          </Col>
        </Row>
        <Form>
          <Modal
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            closable={true}
            footer={[
              <Button
                key="submit"
                className="cancel"
                onClick={this.handleCancel}
              >
                Cancel
              </Button>,
              <Button
                type="primary"
                htmlType="submit"
                loading={this.state.loading}
                onClick={this.updateSizes}
              >
                Update
              </Button>,
            ]}
          >
            <CloseOutlined
              onClick={this.handleCancel}
              style={{ float: "right", cursor: "pointer", fontSize: "1.4em" }}
            />
            <div style={{ marginTop: "10%" }}>
              <h1 style={{ textAlign: "center" }}>Sizes & Prices Details</h1>
              <p style={{ textAlign: "center" }}>{this.state.productName}</p>
              <Table
                columns={priceColumns}
                dataSource={this.state.priceData}
                pagination={false}
              />
            </div>
          </Modal>
        </Form>

        <Modal
          visible={this.state.loginModal}
          onOk={this.handleLoginOk}
          onCancel={this.handleLoginCancel}
          closable={true}
          footer={[
            // <Button key="submit" className="assigning" onClick={this.handleLoginOk}>
            //     Send Password
            // </Button>,
            this.state?.loginDetails &&
              "isActive" in this.state?.loginDetails &&
              !this.state?.loginDetails?.isActive && (
                <Button
                  key="submit"
                  htmlType="submit"
                  loading={this.state.avtivationLoading}
                  className="assigning"
                  onClick={() => {
                    this.resendConfirmationCode(
                      this.state?.loginDetails?.["email"]
                    );
                  }}
                >
                  Resend Activation Code
                </Button>
              ),
            // <span style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }} onClick={() => { this.resendConfirmationCode(id) }}>Resend Activation Code</span>
          ]}
        >
          <CloseOutlined
            onClick={this.handleLoginCancel}
            style={{ float: "right", cursor: "pointer", fontSize: "1.4em" }}
          />
          <div style={{ marginTop: "10%" }}>
            <h1 style={{ textAlign: "center" }}>Login Details</h1>
            <p>Email</p>
            <h3>{this.state?.loginDetails?.["email"]}</h3>
          </div>
        </Modal>

        <Form>
          <Modal
            visible={this.state.profileVisible}
            // onOk={this.profileHandleOk}
            // onCancel={this.profileHandleCancel}
            closable={true}
            footer={[
              <Button
                key="submit"
                className="cancel"
                onClick={this.profileHandleCancel}
              >
                Cancel
              </Button>,
              <Button
                type="primary"
                key="editSubmit"
                htmlType="submit"
                loading={this.state.loading}
                onClick={this.updateUserDetails}
              >
                Update
              </Button>,
            ]}
          >
            <CloseOutlined
              onClick={this.profileHandleCancel}
              style={{ float: "right", cursor: "pointer", fontSize: "1.4em" }}
            />

            <div style={{ marginTop: "10%" }}>
              <h1 style={{ textAlign: "center" }}>Edit Profile</h1>
              <Row gutter={10}>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span style={{ color: "#0E4D90" }}>First Name</span>}
                  >
                    {getFieldDecorator("firstName", {
                      initialValue: "",
                      rules: [
                        {
                          required: true,
                          message: "Please input your First Name",
                        },
                        noWhitespaceRule,
                      ],
                    })(<Input />)}
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span style={{ color: "#0E4D90" }}>Last Name</span>}
                  >
                    {getFieldDecorator("lastName", {
                      initialValue: "",
                      rules: [
                        {
                          required: true,
                          message: "Please input your Last Name",
                        },
                        noWhitespaceRule,
                      ],
                    })(<Input />)}
                  </Form.Item>
                </Col>
                {/* <Col lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={
                      <span style={{ color: "#0E4D90" }}>Mobile Number</span>
                    }
                  >
                    {getFieldDecorator("phone", {
                      initialValue: "",
                      rules: [
                        {
                          required: true,
                          message: "Please input your Mobile Number",
                        },
                        noWhitespaceRule,
                        notValidPhoneNumberRule,
                      ],
                    })(<Input />)}
                  </Form.Item>
                </Col> */}
                <Col lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={
                      <span style={{ color: "#0E4D90" }}>Company Name</span>
                    }
                  >
                    {getFieldDecorator("companyName", {
                      initialValue: "",
                      rules: [
                        {
                          required: true,
                          message: "Please input your Company Name",
                        },
                        noWhitespaceRule,
                      ],
                    })(<Input />)}
                  </Form.Item>
                </Col>

                <Col lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span style={{ color: "#0E4D90" }}>Address</span>}
                  >
                    {getFieldDecorator("address", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your Address",
                        },
                      ],
                    })(
                      <LocationAutocomplete
                        getAddress={(address, latLng) =>
                          this.getAddress(address, latLng, "address")
                        }
                        editMode={true}
                        address={this.state.selectedCustomerAddress}
                        setAddress={(address) => {
                          this.setState({ selectedCustomerAddress: address });
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
                {/* <Col lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span style={{ color: "#0E4D90" }}>Email</span>}
                  >
                    {getFieldDecorator("email", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your Address",
                        },
                      ],
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col> */}
              </Row>
            </div>
          </Modal>
        </Form>

        <Form>
          <Modal
            visible={this.state.locationsVisible}
            title={this.state.locationModalTitle}
            onOk={this.locationHandleOk}
            onCancel={this.locationHandleCancel}
            footer={[
              <Button
                key="back"
                className="cancel"
                onClick={this.locationHandleCancel}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                className="assigning"
                loading={this.state.locationLoading}
                onClick={this.locationHandleOk}
              >
                Save
              </Button>,
            ]}
          >
            <Row>
              <Form.Item
                className="Formitem"
                label={<span style={{ color: "#0E4D90" }}>Location Name</span>}
              >
                {getFieldDecorator("LocationName1", {
                  initialValue: "",
                  rules: [
                    {
                      required: true,
                      message: "Please input your Location Name",
                    },
                  ],
                })(<Input />)}
              </Form.Item>
              <Form.Item
                className="Formitem"
                label={<span style={{ color: "#0E4D90" }}>Address</span>}
              >
                {getFieldDecorator("Address1", {
                  rules: [
                    { required: true, message: "Please input your Address" },
                  ],
                })(
                  <LocationAutocomplete
                    getAddress={(address, latLng) =>
                      this.getAddress(address, latLng, "Address1")
                    }
                    editMode={this.state.editMode}
                    address={this.state.selectedAddress}
                    setAddress={(address) => {
                      this.setState({ selectedAddress: address });
                    }}
                  />
                )}
              </Form.Item>
            </Row>
          </Modal>
        </Form>

        <Form>
          <Modal
            visible={this.state.customerApproval}
            title={""}
            onOk={this.approveCustomer}
            onCancel={() => {
              this.setState({ customerApproval: false });
            }}
            footer={[
              <Button
                key="back"
                className="cancel"
                onClick={() => {
                  this.setState({ customerApproval: false });
                  this.props.form.setFieldsValue({
                    creditAmount: this.state.customerInfo["creditAmount"],
                  });
                }}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                className="assigning"
                loading={this.state.approveLoading}
                onClick={this.approveCustomer}
              >
                Save
              </Button>,
            ]}
          >
            <Row>
              <Form.Item
                className="Formitem"
                label={<span style={{ color: "#0E4D90" }}>Credit Amount</span>}
              >
                {getFieldDecorator("creditAmount", {
                  initialValue: this.state.customerInfo["creditAmount"],
                  rules: [
                    {
                      required: true,
                      message: "Please input credit amount",
                    },
                  ],
                })(<Input prefix="$" onKeyPress={this.handleKeyDown} />)}
              </Form.Item>
            </Row>
          </Modal>
        </Form>

        <Form>
          <Modal
            visible={this.state.documentVisible}
            title={this.state.documentTitle}
            onOk={this.handleUpload}
            onCancel={() => {
              this.setState({ documentVisible: false, documentTitle: "" });
            }}
            footer={[
              <Button
                key="back"
                className="cancel"
                onClick={() => {
                  this.setState({
                    documentVisible: false,
                    documentTitle: "",
                    fileList: [],
                  });
                  this.props.form.setFieldsValue({
                    creditAmount: this.state.customerInfo["creditAmount"],
                  });
                }}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                className="assigning"
                loading={this.state.uploading}
                onClick={this.handleUpload}
              >
                Save
              </Button>,
            ]}
          >
            <Row>
              <Form.Item>
                {getFieldDecorator("credit app")}
                <li>
                  <Row>
                    <Col span={6}>
                      <>
                        <img
                          src={Uploaded}
                          style={{ marginRight: 10 }}
                          alt="img"
                        />
                        Credit App
                      </>
                    </Col>
                    <Col span={8}>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.creditAppDownload(
                            "DeFeoMaterialsCreditApp14Days.pdf"
                          );
                        }}
                      >
                        <h4
                          style={{
                            color: "#7B8190",
                            fontSize: "13px",
                            textAlign: "center",
                          }}
                        >
                          Blank DeFeo Materials Credit Application &nbsp;{" "}
                          <img
                            src={Docsample}
                            alt="Doc"
                            title="Download"
                            style={{ width: "25px", height: "30px" }}
                          />
                        </h4>
                      </span>
                    </Col>
                    <Col span={10}>
                      <div style={{ marginLeft: "40px" }}>
                        <Upload name="credit app" {...firstupload}>
                          <Button
                            className="uploadButton"
                            onClick={() => {
                              this.setState({
                                uploadName: "creditApp",
                              });
                            }}
                          >
                            <Icon type="upload" />
                            Upload
                          </Button>
                        </Upload>
                      </div>
                    </Col>
                  </Row>
                </li>
              </Form.Item>
              <Form.Item>
                {getFieldDecorator("resale")}
                <li>
                  <Row>
                    <Col span={8}>
                      <>
                        <img
                          src={Uploaded}
                          style={{ marginRight: 10 }}
                          alt="img"
                        />
                        Resale Certificate
                      </>
                    </Col>
                    <Col span={16}>
                      <div style={{ marginLeft: "45%" }}>
                        <Upload name="resale" {...secondupload}>
                          <Button
                            className="uploadButton"
                            onClick={() => {
                              this.setState({ uploadName: "rc" });
                            }}
                          >
                            <Icon type="upload" />
                            Upload
                          </Button>
                        </Upload>
                      </div>
                    </Col>
                  </Row>
                </li>
              </Form.Item>
              {/* <Form.Item style={{ textAlign: "center", marginTop: "10%" }}>
                <Button
                  key="back"
                  className="cancel"
                  onClick={() => {
                    this.setState({ customerApproval: false });
                    this.props.form.setFieldsValue({
                      creditAmount: this.state.customerInfo["creditAmount"],
                    });
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  onClick={this.handleUpload}
                  loading={uploading}
                  style={{ color: "white" }}
                >
                  Submit
                </Button>
              </Form.Item> */}
            </Row>
          </Modal>
        </Form>

        <Form>
          <Modal
            visible={this.state.subUserEdit}
            title={"Edit Subuser Details"}
            onOk={this.handleEditSubUser}
            onCancel={this.handleEditSubUserCancel}
            footer={[
              <Button
                key="back"
                className="cancel"
                onClick={this.handleEditSubUserCancel}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                className="assigning"
                loading={this.state.formSubmitStatus}
                onClick={this.handleEditSubUser}
              >
                Save
              </Button>,
            ]}
          >
            <FormItem>
              <div style={{ marginTop: "7%" }}>
                <Row gutter={10}>
                  <Col span={12}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          First Name
                        </span>
                      }
                    >
                      {getFieldDecorator("subUserfirstName", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your Full Name!",
                          },
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          Last Name
                        </span>
                      }
                    >
                      {getFieldDecorator("subUserlastName", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your Company Name!",
                          },
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          Phone
                        </span>
                      }
                    >
                      {getFieldDecorator("subUserphone", {
                        rules: [
                          { message: "The input is not valid phone number!" },
                          {
                            required: true,
                            message: "Please input your phone number!",
                          },
                        ],
                      })(<Input style={{ width: "100%" }} disabled={true} />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          Email
                        </span>
                      }
                    >
                      {getFieldDecorator("subUseremail", {
                        rules: [
                          {
                            type: "email",
                            message: "The input is not valid E-mail!",
                          },
                          {
                            required: true,
                            message: "Please input your E-mail!",
                          },
                        ],
                      })(<Input disabled={true} />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col lg={24} md={24} sm={24} sx={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span
                          style={{
                            color: "#7B8190",
                            fontSize: "14px",
                            paddingTop: "10px",
                          }}
                        >
                          User Profile
                        </span>
                      }
                    >
                      {getFieldDecorator("subUseruserProfile", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your User Profile!",
                          },
                        ],
                      })(
                        <Select>
                          <Option value="CU">Customer Admin</Option>
                          <Option value="SCU">Sub User</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col lg={24} md={24} sm={24} sx={24}></Col>
                </Row>
              </div>
            </FormItem>
          </Modal>
        </Form>

        <Form>
          <Modal
            className="modal-black-close"
            title={this.state.title}
            visible={this.state.noteVisible}
            onCancel={() => {
              this.setState({ noteVisible: false });
            }}
            footer={[
              <Button
                // key="submit"
                className="cancel"
                onClick={() => {
                  this.setState({ noteVisible: false });
                }}
              >
                Cancel
              </Button>,
              <Button
                type="primary"
                key="editSubmit"
                htmlType="submit"
                loading={this.state.loading}
                onClick={this.updateNoteDetails}
              >
                {this.state.buttonText}
              </Button>,
            ]}
          >
            <Row>
              <RichText
                handleRichtextBio={this.handleRichtextBio}
                richtTextBiofieldProp={
                  this.state?.loginDetails &&
                  this.state?.loginDetails?.richTextEditior
                    ? this.state?.loginDetails?.richTextEditior
                    : ""
                }
              />
            </Row>
          </Modal>
        </Form>
        <Form>
          <Modal
            visible={this.state.pricesheetModal}
            closable={true}
            title={""}
            onOk={this.confirm}
            onCancel={() => {
              this.setState({ pricesheetModal: false });
            }}
            footer={[
              <Button
                key="back"
                className="cancel"
                onClick={() => {
                  this.props.form.resetFields();
                  this.setState({ pricesheetModal: false });
                }}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                className="assigning"
                loading={this.state.sendMailloading}
                onClick={this.confirm}
              >
                Send
              </Button>,
            ]}
          >
            <Row>
              <CloseOutlined
                onClick={() => {
                  this.props.form.resetFields();
                  this.setState({ pricesheetModal: false });
                }}
                style={{
                  float: "right",
                  cursor: "pointer",
                  fontSize: "1.4em",
                }}
              />
              <Col lg={24} md={24} sm={24} xs={24}>
                <Form.Item
                  className="Formitem"
                  label={<span style={{ color: "#0E4D90" }}>Email</span>}
                >
                  {getFieldDecorator("emails", {
                    rules: [
                      {
                        required: true,
                        message: "Please select email",
                      },
                    ],
                  })(
                    <Select
                      mode="multiple"
                      allowClear
                      style={{ width: "100%" }}
                      placeholder="Please Select email"
                      showArrow
                    >
                      {this.state.allUserList.map((alluser) => (
                        <Option value={alluser.email} key={alluser.id}>
                          {alluser.email}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
                <Form.Item
                  className="Formitem"
                  label={<span style={{ color: "#0E4D90" }}>Location</span>}
                >
                  {getFieldDecorator("location", {
                    rules: [
                      {
                        required: true,
                        message:
                          "Please select location for which you want to send pricesheet",
                      },
                    ],
                  })(
                    <Select
                      // mode="multiple"
                      allowClear
                      style={{ width: "100%" }}
                      placeholder="Please Select Location"
                      showArrow
                    >
                      {this.state.locations.map(
                        (l) =>
                          l.isActive !== false && (
                            <Option value={l.location} key={l.location}>
                              {l.location}
                            </Option>
                          )
                      )}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Modal>
        </Form>
      </div>
    );
  }
}

export default Form.create({ name: "customerDetails" })(
  withAppContext(withRouter(CustomerDetails))
);
